'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var classNames = require('classnames');
var reactDeviceDetect = require('react-device-detect');
var MenuWrapper = require('@piconetworks/menu-wrapper');
var Avatar = require('@piconetworks/avatar');
var functions = require('@piconetworks/functions');
var Tooltip = require('@piconetworks/tooltip');
var Icon = require('@piconetworks/icon');
var Account = require('@piconetworks/account');
var moment = require('moment');
var currency = require('@piconetworks/currency');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var MenuWrapper__default = /*#__PURE__*/_interopDefaultLegacy(MenuWrapper);
var Avatar__default = /*#__PURE__*/_interopDefaultLegacy(Avatar);
var Tooltip__default = /*#__PURE__*/_interopDefaultLegacy(Tooltip);
var Icon__default = /*#__PURE__*/_interopDefaultLegacy(Icon);
var Account__default = /*#__PURE__*/_interopDefaultLegacy(Account);
var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);
var currency__default = /*#__PURE__*/_interopDefaultLegacy(currency);

var style = {"align-baseline":"MenuRoutes-module_align-baseline__1_NUg","align-top":"MenuRoutes-module_align-top__1k784","align-middle":"MenuRoutes-module_align-middle__1ygnt","align-bottom":"MenuRoutes-module_align-bottom__ptQul","align-text-bottom":"MenuRoutes-module_align-text-bottom__3-4KG","align-text-top":"MenuRoutes-module_align-text-top__1ZdJk","bg-primary":"MenuRoutes-module_bg-primary__3yhRG","bg-secondary":"MenuRoutes-module_bg-secondary__3P2qm","bg-success":"MenuRoutes-module_bg-success__3iaAJ","bg-info":"MenuRoutes-module_bg-info__2YTJ3","bg-warning":"MenuRoutes-module_bg-warning__3O7Ru","bg-danger":"MenuRoutes-module_bg-danger__3-JA3","bg-light":"MenuRoutes-module_bg-light__3ZmjH","bg-dark":"MenuRoutes-module_bg-dark__2nOED","bg-facebook":"MenuRoutes-module_bg-facebook__2tZEH","bg-google":"MenuRoutes-module_bg-google__14tmO","bg-white":"MenuRoutes-module_bg-white__1Zaei","bg-transparent":"MenuRoutes-module_bg-transparent__28BTV","border":"MenuRoutes-module_border__3QQIf","border-top":"MenuRoutes-module_border-top__2Pt9i","border-right":"MenuRoutes-module_border-right__3prbP","border-bottom":"MenuRoutes-module_border-bottom__16gKa","border-left":"MenuRoutes-module_border-left__8fyS3","border-0":"MenuRoutes-module_border-0__sucn1","border-top-0":"MenuRoutes-module_border-top-0__3ZsyY","border-right-0":"MenuRoutes-module_border-right-0__1Ywun","border-bottom-0":"MenuRoutes-module_border-bottom-0__3P0yi","border-left-0":"MenuRoutes-module_border-left-0__3Fe-b","border-primary":"MenuRoutes-module_border-primary__LI85b","border-secondary":"MenuRoutes-module_border-secondary__2-Jt-","border-success":"MenuRoutes-module_border-success__X9Jnc","border-info":"MenuRoutes-module_border-info__T-F1E","border-warning":"MenuRoutes-module_border-warning__33IcF","border-danger":"MenuRoutes-module_border-danger__1gH5T","border-light":"MenuRoutes-module_border-light__1UEE7","border-dark":"MenuRoutes-module_border-dark__1faj6","border-facebook":"MenuRoutes-module_border-facebook__26I7k","border-google":"MenuRoutes-module_border-google__3SpWb","border-white":"MenuRoutes-module_border-white__mq_mK","rounded-sm":"MenuRoutes-module_rounded-sm__2xmao","rounded":"MenuRoutes-module_rounded__QMStI","rounded-top":"MenuRoutes-module_rounded-top__389Hr","rounded-right":"MenuRoutes-module_rounded-right__uOgMu","rounded-bottom":"MenuRoutes-module_rounded-bottom__2YtSV","rounded-left":"MenuRoutes-module_rounded-left__AATDz","rounded-lg":"MenuRoutes-module_rounded-lg__3Bjc6","rounded-circle":"MenuRoutes-module_rounded-circle__31vua","rounded-pill":"MenuRoutes-module_rounded-pill__BLAeW","rounded-0":"MenuRoutes-module_rounded-0__2tTWd","clearfix":"MenuRoutes-module_clearfix__2XfdQ","d-none":"MenuRoutes-module_d-none__1xCUN","d-inline":"MenuRoutes-module_d-inline__330su","d-inline-block":"MenuRoutes-module_d-inline-block__27OIu","d-block":"MenuRoutes-module_d-block__X-ESj","d-table":"MenuRoutes-module_d-table__1BIUY","d-table-row":"MenuRoutes-module_d-table-row__3vLwq","d-table-cell":"MenuRoutes-module_d-table-cell__F4KLd","d-flex":"MenuRoutes-module_d-flex__3u8ZO","d-inline-flex":"MenuRoutes-module_d-inline-flex__1imPA","d-sm-none":"MenuRoutes-module_d-sm-none__15obM","d-sm-inline":"MenuRoutes-module_d-sm-inline__3gCS7","d-sm-inline-block":"MenuRoutes-module_d-sm-inline-block__3Inei","d-sm-block":"MenuRoutes-module_d-sm-block__19VVe","d-sm-table":"MenuRoutes-module_d-sm-table__1c5vi","d-sm-table-row":"MenuRoutes-module_d-sm-table-row__2q9eu","d-sm-table-cell":"MenuRoutes-module_d-sm-table-cell__3MOaM","d-sm-flex":"MenuRoutes-module_d-sm-flex__3mmoy","d-sm-inline-flex":"MenuRoutes-module_d-sm-inline-flex__PsU2d","d-md-none":"MenuRoutes-module_d-md-none__XeMs9","d-md-inline":"MenuRoutes-module_d-md-inline__jNExQ","d-md-inline-block":"MenuRoutes-module_d-md-inline-block__2cXfO","d-md-block":"MenuRoutes-module_d-md-block__28_q6","d-md-table":"MenuRoutes-module_d-md-table__2qAyR","d-md-table-row":"MenuRoutes-module_d-md-table-row__23DTu","d-md-table-cell":"MenuRoutes-module_d-md-table-cell__35xOk","d-md-flex":"MenuRoutes-module_d-md-flex__1XBr9","d-md-inline-flex":"MenuRoutes-module_d-md-inline-flex__1kSdU","d-lg-none":"MenuRoutes-module_d-lg-none__1TuU1","d-lg-inline":"MenuRoutes-module_d-lg-inline__ERGbo","d-lg-inline-block":"MenuRoutes-module_d-lg-inline-block__1XGHi","d-lg-block":"MenuRoutes-module_d-lg-block__E1vTS","d-lg-table":"MenuRoutes-module_d-lg-table__1WL9E","d-lg-table-row":"MenuRoutes-module_d-lg-table-row__3P9qs","d-lg-table-cell":"MenuRoutes-module_d-lg-table-cell__3m0w5","d-lg-flex":"MenuRoutes-module_d-lg-flex__2K2Sj","d-lg-inline-flex":"MenuRoutes-module_d-lg-inline-flex__1SQN1","d-xl-none":"MenuRoutes-module_d-xl-none__1LtzB","d-xl-inline":"MenuRoutes-module_d-xl-inline__3oCNd","d-xl-inline-block":"MenuRoutes-module_d-xl-inline-block__WlwNS","d-xl-block":"MenuRoutes-module_d-xl-block__3J-55","d-xl-table":"MenuRoutes-module_d-xl-table__331FN","d-xl-table-row":"MenuRoutes-module_d-xl-table-row__1Tsqa","d-xl-table-cell":"MenuRoutes-module_d-xl-table-cell__39aEn","d-xl-flex":"MenuRoutes-module_d-xl-flex__3I35-","d-xl-inline-flex":"MenuRoutes-module_d-xl-inline-flex__lnMKo","d-print-none":"MenuRoutes-module_d-print-none__3BwEv","d-print-inline":"MenuRoutes-module_d-print-inline__2JW4D","d-print-inline-block":"MenuRoutes-module_d-print-inline-block__374C6","d-print-block":"MenuRoutes-module_d-print-block__1j8rw","d-print-table":"MenuRoutes-module_d-print-table__1_C8w","d-print-table-row":"MenuRoutes-module_d-print-table-row__iFRjJ","d-print-table-cell":"MenuRoutes-module_d-print-table-cell__2Qojf","d-print-flex":"MenuRoutes-module_d-print-flex__1SmJr","d-print-inline-flex":"MenuRoutes-module_d-print-inline-flex__1DPtn","embed-responsive":"MenuRoutes-module_embed-responsive__2EYvP","embed-responsive-item":"MenuRoutes-module_embed-responsive-item__2xD_i","embed-responsive-21by9":"MenuRoutes-module_embed-responsive-21by9__3UtlC","embed-responsive-16by9":"MenuRoutes-module_embed-responsive-16by9__20bG2","embed-responsive-4by3":"MenuRoutes-module_embed-responsive-4by3__iNdLJ","embed-responsive-1by1":"MenuRoutes-module_embed-responsive-1by1__Pftp6","flex-row":"MenuRoutes-module_flex-row__2CeKd","flex-column":"MenuRoutes-module_flex-column__cef7h","flex-row-reverse":"MenuRoutes-module_flex-row-reverse__3Gwtd","flex-column-reverse":"MenuRoutes-module_flex-column-reverse__1oG21","flex-wrap":"MenuRoutes-module_flex-wrap__30ukh","flex-nowrap":"MenuRoutes-module_flex-nowrap__10AvF","flex-wrap-reverse":"MenuRoutes-module_flex-wrap-reverse__2LK0H","flex-fill":"MenuRoutes-module_flex-fill__cd2Wr","flex-grow-0":"MenuRoutes-module_flex-grow-0__2tSzw","flex-grow-1":"MenuRoutes-module_flex-grow-1__2jVav","flex-shrink-0":"MenuRoutes-module_flex-shrink-0__Pbcfu","flex-shrink-1":"MenuRoutes-module_flex-shrink-1__3iF8r","justify-content-start":"MenuRoutes-module_justify-content-start__6Kolj","justify-content-end":"MenuRoutes-module_justify-content-end__eVJiz","justify-content-center":"MenuRoutes-module_justify-content-center__Zj_x-","justify-content-between":"MenuRoutes-module_justify-content-between__wFh0T","justify-content-around":"MenuRoutes-module_justify-content-around__6Spye","align-items-start":"MenuRoutes-module_align-items-start__f1yL3","align-items-end":"MenuRoutes-module_align-items-end__2fbIy","align-items-center":"MenuRoutes-module_align-items-center__2cIEr","align-items-baseline":"MenuRoutes-module_align-items-baseline__3Jx5N","align-items-stretch":"MenuRoutes-module_align-items-stretch__18fyJ","align-content-start":"MenuRoutes-module_align-content-start__1vGET","align-content-end":"MenuRoutes-module_align-content-end__3ZZn7","align-content-center":"MenuRoutes-module_align-content-center__3Om-W","align-content-between":"MenuRoutes-module_align-content-between__3ckei","align-content-around":"MenuRoutes-module_align-content-around__3l9HC","align-content-stretch":"MenuRoutes-module_align-content-stretch__1uIYw","align-self-auto":"MenuRoutes-module_align-self-auto__jJtb7","align-self-start":"MenuRoutes-module_align-self-start__2aWQJ","align-self-end":"MenuRoutes-module_align-self-end__dcQp2","align-self-center":"MenuRoutes-module_align-self-center__36Y-Q","align-self-baseline":"MenuRoutes-module_align-self-baseline__34UuH","align-self-stretch":"MenuRoutes-module_align-self-stretch__1ysY6","flex-sm-row":"MenuRoutes-module_flex-sm-row__Mgjko","flex-sm-column":"MenuRoutes-module_flex-sm-column__1q58b","flex-sm-row-reverse":"MenuRoutes-module_flex-sm-row-reverse__2I9gs","flex-sm-column-reverse":"MenuRoutes-module_flex-sm-column-reverse__1--nE","flex-sm-wrap":"MenuRoutes-module_flex-sm-wrap__1ex1Z","flex-sm-nowrap":"MenuRoutes-module_flex-sm-nowrap__3YWIw","flex-sm-wrap-reverse":"MenuRoutes-module_flex-sm-wrap-reverse__G_-Np","flex-sm-fill":"MenuRoutes-module_flex-sm-fill__38aOL","flex-sm-grow-0":"MenuRoutes-module_flex-sm-grow-0__2yWu7","flex-sm-grow-1":"MenuRoutes-module_flex-sm-grow-1__2IgW5","flex-sm-shrink-0":"MenuRoutes-module_flex-sm-shrink-0__3SfEp","flex-sm-shrink-1":"MenuRoutes-module_flex-sm-shrink-1__18N7y","justify-content-sm-start":"MenuRoutes-module_justify-content-sm-start__1z4r6","justify-content-sm-end":"MenuRoutes-module_justify-content-sm-end__19j8q","justify-content-sm-center":"MenuRoutes-module_justify-content-sm-center__3ggfQ","justify-content-sm-between":"MenuRoutes-module_justify-content-sm-between__26DOA","justify-content-sm-around":"MenuRoutes-module_justify-content-sm-around__2k55B","align-items-sm-start":"MenuRoutes-module_align-items-sm-start__1X0Rh","align-items-sm-end":"MenuRoutes-module_align-items-sm-end__2SLtd","align-items-sm-center":"MenuRoutes-module_align-items-sm-center__2WLU2","align-items-sm-baseline":"MenuRoutes-module_align-items-sm-baseline__IpqKH","align-items-sm-stretch":"MenuRoutes-module_align-items-sm-stretch__RXlyw","align-content-sm-start":"MenuRoutes-module_align-content-sm-start__1ROVp","align-content-sm-end":"MenuRoutes-module_align-content-sm-end__ZBIeE","align-content-sm-center":"MenuRoutes-module_align-content-sm-center__3zXFW","align-content-sm-between":"MenuRoutes-module_align-content-sm-between__20909","align-content-sm-around":"MenuRoutes-module_align-content-sm-around__sgNqE","align-content-sm-stretch":"MenuRoutes-module_align-content-sm-stretch__3vAWK","align-self-sm-auto":"MenuRoutes-module_align-self-sm-auto__1fS-c","align-self-sm-start":"MenuRoutes-module_align-self-sm-start__xOct2","align-self-sm-end":"MenuRoutes-module_align-self-sm-end__2-i-g","align-self-sm-center":"MenuRoutes-module_align-self-sm-center__1i1US","align-self-sm-baseline":"MenuRoutes-module_align-self-sm-baseline__nZrLx","align-self-sm-stretch":"MenuRoutes-module_align-self-sm-stretch__DtQLN","flex-md-row":"MenuRoutes-module_flex-md-row__3wKD9","flex-md-column":"MenuRoutes-module_flex-md-column__aoEv6","flex-md-row-reverse":"MenuRoutes-module_flex-md-row-reverse__1rMdj","flex-md-column-reverse":"MenuRoutes-module_flex-md-column-reverse__3Ie0E","flex-md-wrap":"MenuRoutes-module_flex-md-wrap__11DDy","flex-md-nowrap":"MenuRoutes-module_flex-md-nowrap__1uDWT","flex-md-wrap-reverse":"MenuRoutes-module_flex-md-wrap-reverse__1hGqz","flex-md-fill":"MenuRoutes-module_flex-md-fill__2OSFU","flex-md-grow-0":"MenuRoutes-module_flex-md-grow-0__Wxzl5","flex-md-grow-1":"MenuRoutes-module_flex-md-grow-1__16ksQ","flex-md-shrink-0":"MenuRoutes-module_flex-md-shrink-0__LRJmj","flex-md-shrink-1":"MenuRoutes-module_flex-md-shrink-1__2jVN6","justify-content-md-start":"MenuRoutes-module_justify-content-md-start__1X7WB","justify-content-md-end":"MenuRoutes-module_justify-content-md-end__1VKMr","justify-content-md-center":"MenuRoutes-module_justify-content-md-center__2h-w9","justify-content-md-between":"MenuRoutes-module_justify-content-md-between__sNxvu","justify-content-md-around":"MenuRoutes-module_justify-content-md-around__NK9id","align-items-md-start":"MenuRoutes-module_align-items-md-start__1e8Z9","align-items-md-end":"MenuRoutes-module_align-items-md-end__14Pqf","align-items-md-center":"MenuRoutes-module_align-items-md-center__1pazi","align-items-md-baseline":"MenuRoutes-module_align-items-md-baseline__6PHK3","align-items-md-stretch":"MenuRoutes-module_align-items-md-stretch__30stB","align-content-md-start":"MenuRoutes-module_align-content-md-start__2g67f","align-content-md-end":"MenuRoutes-module_align-content-md-end__28x5G","align-content-md-center":"MenuRoutes-module_align-content-md-center__nkVfm","align-content-md-between":"MenuRoutes-module_align-content-md-between__-v5Sj","align-content-md-around":"MenuRoutes-module_align-content-md-around__3nV_e","align-content-md-stretch":"MenuRoutes-module_align-content-md-stretch__a6iky","align-self-md-auto":"MenuRoutes-module_align-self-md-auto__3ej9w","align-self-md-start":"MenuRoutes-module_align-self-md-start__2JBHz","align-self-md-end":"MenuRoutes-module_align-self-md-end__2CZdP","align-self-md-center":"MenuRoutes-module_align-self-md-center__a25-R","align-self-md-baseline":"MenuRoutes-module_align-self-md-baseline__o24YZ","align-self-md-stretch":"MenuRoutes-module_align-self-md-stretch__1dLo0","flex-lg-row":"MenuRoutes-module_flex-lg-row__3-kzE","flex-lg-column":"MenuRoutes-module_flex-lg-column__f8S6m","flex-lg-row-reverse":"MenuRoutes-module_flex-lg-row-reverse__1BDvB","flex-lg-column-reverse":"MenuRoutes-module_flex-lg-column-reverse__2DQvk","flex-lg-wrap":"MenuRoutes-module_flex-lg-wrap__2n7HP","flex-lg-nowrap":"MenuRoutes-module_flex-lg-nowrap__3MG2x","flex-lg-wrap-reverse":"MenuRoutes-module_flex-lg-wrap-reverse__2L46l","flex-lg-fill":"MenuRoutes-module_flex-lg-fill__3302x","flex-lg-grow-0":"MenuRoutes-module_flex-lg-grow-0__2sBtM","flex-lg-grow-1":"MenuRoutes-module_flex-lg-grow-1__2VnRD","flex-lg-shrink-0":"MenuRoutes-module_flex-lg-shrink-0__3Z0PV","flex-lg-shrink-1":"MenuRoutes-module_flex-lg-shrink-1__2lT3x","justify-content-lg-start":"MenuRoutes-module_justify-content-lg-start__bCon0","justify-content-lg-end":"MenuRoutes-module_justify-content-lg-end__2AOU6","justify-content-lg-center":"MenuRoutes-module_justify-content-lg-center__3tCpU","justify-content-lg-between":"MenuRoutes-module_justify-content-lg-between__rjlwe","justify-content-lg-around":"MenuRoutes-module_justify-content-lg-around__2hg3a","align-items-lg-start":"MenuRoutes-module_align-items-lg-start__eMG5V","align-items-lg-end":"MenuRoutes-module_align-items-lg-end__2SKm3","align-items-lg-center":"MenuRoutes-module_align-items-lg-center__YYp7T","align-items-lg-baseline":"MenuRoutes-module_align-items-lg-baseline__-94bd","align-items-lg-stretch":"MenuRoutes-module_align-items-lg-stretch__3cVyM","align-content-lg-start":"MenuRoutes-module_align-content-lg-start__2LLhZ","align-content-lg-end":"MenuRoutes-module_align-content-lg-end__2VPWL","align-content-lg-center":"MenuRoutes-module_align-content-lg-center__2_e6I","align-content-lg-between":"MenuRoutes-module_align-content-lg-between__5G5tl","align-content-lg-around":"MenuRoutes-module_align-content-lg-around__3NTbK","align-content-lg-stretch":"MenuRoutes-module_align-content-lg-stretch__70Y3r","align-self-lg-auto":"MenuRoutes-module_align-self-lg-auto__X37uL","align-self-lg-start":"MenuRoutes-module_align-self-lg-start__3s9oK","align-self-lg-end":"MenuRoutes-module_align-self-lg-end__3XY0O","align-self-lg-center":"MenuRoutes-module_align-self-lg-center__2qSnR","align-self-lg-baseline":"MenuRoutes-module_align-self-lg-baseline__1XwNz","align-self-lg-stretch":"MenuRoutes-module_align-self-lg-stretch__39i2i","flex-xl-row":"MenuRoutes-module_flex-xl-row__3j0-U","flex-xl-column":"MenuRoutes-module_flex-xl-column__1WqY6","flex-xl-row-reverse":"MenuRoutes-module_flex-xl-row-reverse__3zzBl","flex-xl-column-reverse":"MenuRoutes-module_flex-xl-column-reverse__1GrG6","flex-xl-wrap":"MenuRoutes-module_flex-xl-wrap__1DwdY","flex-xl-nowrap":"MenuRoutes-module_flex-xl-nowrap__26Xw2","flex-xl-wrap-reverse":"MenuRoutes-module_flex-xl-wrap-reverse__1s8ND","flex-xl-fill":"MenuRoutes-module_flex-xl-fill__1nylj","flex-xl-grow-0":"MenuRoutes-module_flex-xl-grow-0__n6dTm","flex-xl-grow-1":"MenuRoutes-module_flex-xl-grow-1__2WaTT","flex-xl-shrink-0":"MenuRoutes-module_flex-xl-shrink-0__15V9P","flex-xl-shrink-1":"MenuRoutes-module_flex-xl-shrink-1__2jeKi","justify-content-xl-start":"MenuRoutes-module_justify-content-xl-start__1zZFm","justify-content-xl-end":"MenuRoutes-module_justify-content-xl-end__34OG2","justify-content-xl-center":"MenuRoutes-module_justify-content-xl-center__2V-9V","justify-content-xl-between":"MenuRoutes-module_justify-content-xl-between__3rCtr","justify-content-xl-around":"MenuRoutes-module_justify-content-xl-around__JbR0s","align-items-xl-start":"MenuRoutes-module_align-items-xl-start__2wryW","align-items-xl-end":"MenuRoutes-module_align-items-xl-end__24jgp","align-items-xl-center":"MenuRoutes-module_align-items-xl-center__2M250","align-items-xl-baseline":"MenuRoutes-module_align-items-xl-baseline__3gycv","align-items-xl-stretch":"MenuRoutes-module_align-items-xl-stretch__1ymB-","align-content-xl-start":"MenuRoutes-module_align-content-xl-start__1c2ZU","align-content-xl-end":"MenuRoutes-module_align-content-xl-end__KURQ6","align-content-xl-center":"MenuRoutes-module_align-content-xl-center__14wIZ","align-content-xl-between":"MenuRoutes-module_align-content-xl-between__3riLV","align-content-xl-around":"MenuRoutes-module_align-content-xl-around__2o8tQ","align-content-xl-stretch":"MenuRoutes-module_align-content-xl-stretch__3ypVb","align-self-xl-auto":"MenuRoutes-module_align-self-xl-auto__1TEii","align-self-xl-start":"MenuRoutes-module_align-self-xl-start__1qGBX","align-self-xl-end":"MenuRoutes-module_align-self-xl-end__1Ch8N","align-self-xl-center":"MenuRoutes-module_align-self-xl-center__59Hqr","align-self-xl-baseline":"MenuRoutes-module_align-self-xl-baseline__YdKTf","align-self-xl-stretch":"MenuRoutes-module_align-self-xl-stretch__22Lrw","float-left":"MenuRoutes-module_float-left__6pREb","float-right":"MenuRoutes-module_float-right__2BO2p","float-none":"MenuRoutes-module_float-none__1mcGS","float-sm-left":"MenuRoutes-module_float-sm-left__3nlWG","float-sm-right":"MenuRoutes-module_float-sm-right__1H1Qb","float-sm-none":"MenuRoutes-module_float-sm-none__3jMrh","float-md-left":"MenuRoutes-module_float-md-left__3RpDS","float-md-right":"MenuRoutes-module_float-md-right__Z7orF","float-md-none":"MenuRoutes-module_float-md-none__ClCD4","float-lg-left":"MenuRoutes-module_float-lg-left__1mF5e","float-lg-right":"MenuRoutes-module_float-lg-right__2AZrD","float-lg-none":"MenuRoutes-module_float-lg-none__3pRay","float-xl-left":"MenuRoutes-module_float-xl-left__1iPZ0","float-xl-right":"MenuRoutes-module_float-xl-right__1eFo9","float-xl-none":"MenuRoutes-module_float-xl-none__jhHDh","overflow-auto":"MenuRoutes-module_overflow-auto__2xnr2","overflow-hidden":"MenuRoutes-module_overflow-hidden__1kBEA","position-static":"MenuRoutes-module_position-static__YoBlS","position-relative":"MenuRoutes-module_position-relative__iNXGP","position-absolute":"MenuRoutes-module_position-absolute__2zT3V","position-fixed":"MenuRoutes-module_position-fixed__1o0Op","position-sticky":"MenuRoutes-module_position-sticky__2Fhkr","fixed-top":"MenuRoutes-module_fixed-top__1jiwY","fixed-bottom":"MenuRoutes-module_fixed-bottom__3YoCX","sticky-top":"MenuRoutes-module_sticky-top__3soc1","sr-only":"MenuRoutes-module_sr-only__2HxnK","sr-only-focusable":"MenuRoutes-module_sr-only-focusable__3LMN_","shadow-sm":"MenuRoutes-module_shadow-sm__3HTr6","shadow":"MenuRoutes-module_shadow__1EQD7","shadow-lg":"MenuRoutes-module_shadow-lg__38mRc","shadow-none":"MenuRoutes-module_shadow-none__3sI9n","w-25":"MenuRoutes-module_w-25__2PdwW","w-50":"MenuRoutes-module_w-50__11skR","w-75":"MenuRoutes-module_w-75__2WLjg","w-100":"MenuRoutes-module_w-100__1cFgY","w-auto":"MenuRoutes-module_w-auto__MaUDS","h-25":"MenuRoutes-module_h-25__1kS2X","h-50":"MenuRoutes-module_h-50__1CxRy","h-75":"MenuRoutes-module_h-75__3AMlG","h-100":"MenuRoutes-module_h-100__1Sfzy","h-auto":"MenuRoutes-module_h-auto__1mle_","mw-100":"MenuRoutes-module_mw-100__6Kh0D","mh-100":"MenuRoutes-module_mh-100__3uWmM","min-vw-100":"MenuRoutes-module_min-vw-100__2kPxV","min-vh-100":"MenuRoutes-module_min-vh-100__g48X7","vw-100":"MenuRoutes-module_vw-100__nvxnM","vh-100":"MenuRoutes-module_vh-100__1tEh2","stretched-link":"MenuRoutes-module_stretched-link__fDvx2","m-0":"MenuRoutes-module_m-0__3qkrL","mt-0":"MenuRoutes-module_mt-0__3qtTa","my-0":"MenuRoutes-module_my-0__AlNU0","mr-0":"MenuRoutes-module_mr-0__2Qquv","mx-0":"MenuRoutes-module_mx-0__3jKLC","mb-0":"MenuRoutes-module_mb-0__1iYVX","ml-0":"MenuRoutes-module_ml-0__3w0zX","m-1":"MenuRoutes-module_m-1__25Nik","mt-1":"MenuRoutes-module_mt-1__2N7AL","my-1":"MenuRoutes-module_my-1__2gC4J","mr-1":"MenuRoutes-module_mr-1__gYeR_","mx-1":"MenuRoutes-module_mx-1__KvoYz","mb-1":"MenuRoutes-module_mb-1__1AEak","ml-1":"MenuRoutes-module_ml-1__mlpFz","m-2":"MenuRoutes-module_m-2__1SOo6","mt-2":"MenuRoutes-module_mt-2__17_lJ","my-2":"MenuRoutes-module_my-2__cXetz","mr-2":"MenuRoutes-module_mr-2__1t1vl","mx-2":"MenuRoutes-module_mx-2__1Ei9E","mb-2":"MenuRoutes-module_mb-2__1QS3H","ml-2":"MenuRoutes-module_ml-2__HmVDV","m-3":"MenuRoutes-module_m-3__35pyy","mt-3":"MenuRoutes-module_mt-3__J0Z1d","my-3":"MenuRoutes-module_my-3__2c_33","mr-3":"MenuRoutes-module_mr-3__23clO","mx-3":"MenuRoutes-module_mx-3__38ufd","mb-3":"MenuRoutes-module_mb-3__35xYL","ml-3":"MenuRoutes-module_ml-3__2Jj7N","m-4":"MenuRoutes-module_m-4__cuUDZ","mt-4":"MenuRoutes-module_mt-4__3mcjI","my-4":"MenuRoutes-module_my-4__3liyi","mr-4":"MenuRoutes-module_mr-4__2hVVt","mx-4":"MenuRoutes-module_mx-4__3d3Tq","mb-4":"MenuRoutes-module_mb-4__lF67a","ml-4":"MenuRoutes-module_ml-4__eH77n","m-5":"MenuRoutes-module_m-5__3yht1","mt-5":"MenuRoutes-module_mt-5__BDXlW","my-5":"MenuRoutes-module_my-5__3VL0a","mr-5":"MenuRoutes-module_mr-5__3wXIK","mx-5":"MenuRoutes-module_mx-5__iduOs","mb-5":"MenuRoutes-module_mb-5__2qhv8","ml-5":"MenuRoutes-module_ml-5__25AKZ","p-0":"MenuRoutes-module_p-0__2RVY_","pt-0":"MenuRoutes-module_pt-0__2DywM","py-0":"MenuRoutes-module_py-0__2tQVA","pr-0":"MenuRoutes-module_pr-0__Rl566","px-0":"MenuRoutes-module_px-0__2SLmF","pb-0":"MenuRoutes-module_pb-0__1vcZX","pl-0":"MenuRoutes-module_pl-0__2_XFt","p-1":"MenuRoutes-module_p-1__2m2bL","pt-1":"MenuRoutes-module_pt-1__3sQWY","py-1":"MenuRoutes-module_py-1__29kWr","pr-1":"MenuRoutes-module_pr-1__1Hnsm","px-1":"MenuRoutes-module_px-1__aQOPM","pb-1":"MenuRoutes-module_pb-1__3CqGt","pl-1":"MenuRoutes-module_pl-1__d64vP","p-2":"MenuRoutes-module_p-2__1eBGI","pt-2":"MenuRoutes-module_pt-2__1fbvU","py-2":"MenuRoutes-module_py-2__1gfl8","pr-2":"MenuRoutes-module_pr-2__1yL2x","px-2":"MenuRoutes-module_px-2__1wsgm","pb-2":"MenuRoutes-module_pb-2__3QYid","pl-2":"MenuRoutes-module_pl-2__17HJ8","p-3":"MenuRoutes-module_p-3__1f0ST","pt-3":"MenuRoutes-module_pt-3__1AtId","py-3":"MenuRoutes-module_py-3__MBRMz","pr-3":"MenuRoutes-module_pr-3__N6T91","px-3":"MenuRoutes-module_px-3__3m6V6","pb-3":"MenuRoutes-module_pb-3__NNmsB","pl-3":"MenuRoutes-module_pl-3__1zRCZ","p-4":"MenuRoutes-module_p-4__1foJy","pt-4":"MenuRoutes-module_pt-4__Kwja3","py-4":"MenuRoutes-module_py-4__3tVPH","pr-4":"MenuRoutes-module_pr-4__3Fgox","px-4":"MenuRoutes-module_px-4___kMSe","pb-4":"MenuRoutes-module_pb-4__1q-ID","pl-4":"MenuRoutes-module_pl-4__2_HF6","p-5":"MenuRoutes-module_p-5__1oKuJ","pt-5":"MenuRoutes-module_pt-5__3i0MR","py-5":"MenuRoutes-module_py-5__2zcw7","pr-5":"MenuRoutes-module_pr-5__1XmHs","px-5":"MenuRoutes-module_px-5__3L-i8","pb-5":"MenuRoutes-module_pb-5__2aBLg","pl-5":"MenuRoutes-module_pl-5__yK-Tz","m-n1":"MenuRoutes-module_m-n1__1HU7C","mt-n1":"MenuRoutes-module_mt-n1__tXDjh","my-n1":"MenuRoutes-module_my-n1__35P-0","mr-n1":"MenuRoutes-module_mr-n1__a6BT8","mx-n1":"MenuRoutes-module_mx-n1__3DnAK","mb-n1":"MenuRoutes-module_mb-n1__Deu8Z","ml-n1":"MenuRoutes-module_ml-n1__2NBPY","m-n2":"MenuRoutes-module_m-n2__3M8HI","mt-n2":"MenuRoutes-module_mt-n2__PH9-k","my-n2":"MenuRoutes-module_my-n2__w0s-g","mr-n2":"MenuRoutes-module_mr-n2__1iMC6","mx-n2":"MenuRoutes-module_mx-n2__VPX3C","mb-n2":"MenuRoutes-module_mb-n2__2HMWm","ml-n2":"MenuRoutes-module_ml-n2__2UQ6r","m-n3":"MenuRoutes-module_m-n3__OHK2F","mt-n3":"MenuRoutes-module_mt-n3__2ACb8","my-n3":"MenuRoutes-module_my-n3__1AnX4","mr-n3":"MenuRoutes-module_mr-n3__2bC35","mx-n3":"MenuRoutes-module_mx-n3__2qQWQ","mb-n3":"MenuRoutes-module_mb-n3__2tVZp","ml-n3":"MenuRoutes-module_ml-n3__3TFSG","m-n4":"MenuRoutes-module_m-n4__WmAMN","mt-n4":"MenuRoutes-module_mt-n4__1vcQM","my-n4":"MenuRoutes-module_my-n4__3nL5-","mr-n4":"MenuRoutes-module_mr-n4__2MAtP","mx-n4":"MenuRoutes-module_mx-n4__3m51h","mb-n4":"MenuRoutes-module_mb-n4__1QX8w","ml-n4":"MenuRoutes-module_ml-n4__1O20P","m-n5":"MenuRoutes-module_m-n5__2NuHk","mt-n5":"MenuRoutes-module_mt-n5__1qIOp","my-n5":"MenuRoutes-module_my-n5__2lF27","mr-n5":"MenuRoutes-module_mr-n5__3mml9","mx-n5":"MenuRoutes-module_mx-n5__2wuvA","mb-n5":"MenuRoutes-module_mb-n5__dsgrF","ml-n5":"MenuRoutes-module_ml-n5__1mkQl","m-auto":"MenuRoutes-module_m-auto__387RK","mt-auto":"MenuRoutes-module_mt-auto__2JMA3","my-auto":"MenuRoutes-module_my-auto__2HqC3","mr-auto":"MenuRoutes-module_mr-auto__2nlaT","mx-auto":"MenuRoutes-module_mx-auto__UdVFk","mb-auto":"MenuRoutes-module_mb-auto__3hFRc","ml-auto":"MenuRoutes-module_ml-auto__U5TVY","m-sm-0":"MenuRoutes-module_m-sm-0__2ID45","mt-sm-0":"MenuRoutes-module_mt-sm-0__1ZesC","my-sm-0":"MenuRoutes-module_my-sm-0__28Enr","mr-sm-0":"MenuRoutes-module_mr-sm-0__2bGo2","mx-sm-0":"MenuRoutes-module_mx-sm-0__2Dmb3","mb-sm-0":"MenuRoutes-module_mb-sm-0__nupj2","ml-sm-0":"MenuRoutes-module_ml-sm-0__19WxN","m-sm-1":"MenuRoutes-module_m-sm-1__jdeyC","mt-sm-1":"MenuRoutes-module_mt-sm-1__20A8n","my-sm-1":"MenuRoutes-module_my-sm-1__1glyz","mr-sm-1":"MenuRoutes-module_mr-sm-1__22IDh","mx-sm-1":"MenuRoutes-module_mx-sm-1__3XCPU","mb-sm-1":"MenuRoutes-module_mb-sm-1__3pokI","ml-sm-1":"MenuRoutes-module_ml-sm-1__3glxz","m-sm-2":"MenuRoutes-module_m-sm-2__lpamG","mt-sm-2":"MenuRoutes-module_mt-sm-2__3RekK","my-sm-2":"MenuRoutes-module_my-sm-2__ougll","mr-sm-2":"MenuRoutes-module_mr-sm-2__3aLed","mx-sm-2":"MenuRoutes-module_mx-sm-2__Q-Zav","mb-sm-2":"MenuRoutes-module_mb-sm-2__1I_l8","ml-sm-2":"MenuRoutes-module_ml-sm-2__2vCjM","m-sm-3":"MenuRoutes-module_m-sm-3__1b6Hx","mt-sm-3":"MenuRoutes-module_mt-sm-3__EzxB-","my-sm-3":"MenuRoutes-module_my-sm-3__PD4FC","mr-sm-3":"MenuRoutes-module_mr-sm-3__2XuHD","mx-sm-3":"MenuRoutes-module_mx-sm-3__4-ePr","mb-sm-3":"MenuRoutes-module_mb-sm-3__2cVXy","ml-sm-3":"MenuRoutes-module_ml-sm-3__18szk","m-sm-4":"MenuRoutes-module_m-sm-4__3H910","mt-sm-4":"MenuRoutes-module_mt-sm-4__L-f67","my-sm-4":"MenuRoutes-module_my-sm-4__3MHq1","mr-sm-4":"MenuRoutes-module_mr-sm-4__yE-UV","mx-sm-4":"MenuRoutes-module_mx-sm-4__nfwym","mb-sm-4":"MenuRoutes-module_mb-sm-4__1YGu2","ml-sm-4":"MenuRoutes-module_ml-sm-4__O6Q64","m-sm-5":"MenuRoutes-module_m-sm-5__1FPCN","mt-sm-5":"MenuRoutes-module_mt-sm-5__1stXI","my-sm-5":"MenuRoutes-module_my-sm-5__2K55H","mr-sm-5":"MenuRoutes-module_mr-sm-5__p3hlS","mx-sm-5":"MenuRoutes-module_mx-sm-5__37s4v","mb-sm-5":"MenuRoutes-module_mb-sm-5__3LBLd","ml-sm-5":"MenuRoutes-module_ml-sm-5__3x10u","p-sm-0":"MenuRoutes-module_p-sm-0__ZcSJ8","pt-sm-0":"MenuRoutes-module_pt-sm-0__3drPf","py-sm-0":"MenuRoutes-module_py-sm-0__1NQBu","pr-sm-0":"MenuRoutes-module_pr-sm-0__1R8Xd","px-sm-0":"MenuRoutes-module_px-sm-0__2-Hsg","pb-sm-0":"MenuRoutes-module_pb-sm-0__2Gt_g","pl-sm-0":"MenuRoutes-module_pl-sm-0__3ga4T","p-sm-1":"MenuRoutes-module_p-sm-1__2eQSN","pt-sm-1":"MenuRoutes-module_pt-sm-1__1gjFB","py-sm-1":"MenuRoutes-module_py-sm-1__g0mT7","pr-sm-1":"MenuRoutes-module_pr-sm-1__3AUt5","px-sm-1":"MenuRoutes-module_px-sm-1__AvmM3","pb-sm-1":"MenuRoutes-module_pb-sm-1__3GCoq","pl-sm-1":"MenuRoutes-module_pl-sm-1__2vKNb","p-sm-2":"MenuRoutes-module_p-sm-2__3JIGX","pt-sm-2":"MenuRoutes-module_pt-sm-2__3IMnS","py-sm-2":"MenuRoutes-module_py-sm-2__13OiM","pr-sm-2":"MenuRoutes-module_pr-sm-2__3CrpU","px-sm-2":"MenuRoutes-module_px-sm-2__ORUIy","pb-sm-2":"MenuRoutes-module_pb-sm-2__aEcnn","pl-sm-2":"MenuRoutes-module_pl-sm-2__2v36f","p-sm-3":"MenuRoutes-module_p-sm-3__2BH2F","pt-sm-3":"MenuRoutes-module_pt-sm-3__1iztO","py-sm-3":"MenuRoutes-module_py-sm-3__38nKM","pr-sm-3":"MenuRoutes-module_pr-sm-3__UNZqi","px-sm-3":"MenuRoutes-module_px-sm-3__2Sj5P","pb-sm-3":"MenuRoutes-module_pb-sm-3__3RMp4","pl-sm-3":"MenuRoutes-module_pl-sm-3__26CBL","p-sm-4":"MenuRoutes-module_p-sm-4__3O5a-","pt-sm-4":"MenuRoutes-module_pt-sm-4__2XZ_X","py-sm-4":"MenuRoutes-module_py-sm-4__1y7TE","pr-sm-4":"MenuRoutes-module_pr-sm-4__3iSMe","px-sm-4":"MenuRoutes-module_px-sm-4__3XJaK","pb-sm-4":"MenuRoutes-module_pb-sm-4__16sf0","pl-sm-4":"MenuRoutes-module_pl-sm-4__16QvP","p-sm-5":"MenuRoutes-module_p-sm-5__1srbS","pt-sm-5":"MenuRoutes-module_pt-sm-5__2-ZR-","py-sm-5":"MenuRoutes-module_py-sm-5__1k13d","pr-sm-5":"MenuRoutes-module_pr-sm-5__3oYNs","px-sm-5":"MenuRoutes-module_px-sm-5__2RdQ1","pb-sm-5":"MenuRoutes-module_pb-sm-5__1jyS0","pl-sm-5":"MenuRoutes-module_pl-sm-5__cgW6J","m-sm-n1":"MenuRoutes-module_m-sm-n1__3M9AR","mt-sm-n1":"MenuRoutes-module_mt-sm-n1__3Yvle","my-sm-n1":"MenuRoutes-module_my-sm-n1__2W0Zi","mr-sm-n1":"MenuRoutes-module_mr-sm-n1__1LX_1","mx-sm-n1":"MenuRoutes-module_mx-sm-n1__JSaur","mb-sm-n1":"MenuRoutes-module_mb-sm-n1__2rBk0","ml-sm-n1":"MenuRoutes-module_ml-sm-n1__3wMiz","m-sm-n2":"MenuRoutes-module_m-sm-n2__t_WPC","mt-sm-n2":"MenuRoutes-module_mt-sm-n2__1ao2j","my-sm-n2":"MenuRoutes-module_my-sm-n2__F8GIT","mr-sm-n2":"MenuRoutes-module_mr-sm-n2__ZGOM8","mx-sm-n2":"MenuRoutes-module_mx-sm-n2__2P0Zl","mb-sm-n2":"MenuRoutes-module_mb-sm-n2__2EqUB","ml-sm-n2":"MenuRoutes-module_ml-sm-n2__11JuK","m-sm-n3":"MenuRoutes-module_m-sm-n3__hR2bD","mt-sm-n3":"MenuRoutes-module_mt-sm-n3__Uwyc2","my-sm-n3":"MenuRoutes-module_my-sm-n3__PE0qn","mr-sm-n3":"MenuRoutes-module_mr-sm-n3__3qCae","mx-sm-n3":"MenuRoutes-module_mx-sm-n3__3vXXE","mb-sm-n3":"MenuRoutes-module_mb-sm-n3__1T2KT","ml-sm-n3":"MenuRoutes-module_ml-sm-n3__FoT9H","m-sm-n4":"MenuRoutes-module_m-sm-n4__3Q880","mt-sm-n4":"MenuRoutes-module_mt-sm-n4__CXjiP","my-sm-n4":"MenuRoutes-module_my-sm-n4__2h5f2","mr-sm-n4":"MenuRoutes-module_mr-sm-n4__-zOol","mx-sm-n4":"MenuRoutes-module_mx-sm-n4__eUchB","mb-sm-n4":"MenuRoutes-module_mb-sm-n4__M1rav","ml-sm-n4":"MenuRoutes-module_ml-sm-n4__2dF00","m-sm-n5":"MenuRoutes-module_m-sm-n5__2Ulvp","mt-sm-n5":"MenuRoutes-module_mt-sm-n5__92Ahd","my-sm-n5":"MenuRoutes-module_my-sm-n5__2be_h","mr-sm-n5":"MenuRoutes-module_mr-sm-n5__HJ0m0","mx-sm-n5":"MenuRoutes-module_mx-sm-n5__LFw8r","mb-sm-n5":"MenuRoutes-module_mb-sm-n5__16iUW","ml-sm-n5":"MenuRoutes-module_ml-sm-n5__21BfV","m-sm-auto":"MenuRoutes-module_m-sm-auto__DeHYF","mt-sm-auto":"MenuRoutes-module_mt-sm-auto__1yJyD","my-sm-auto":"MenuRoutes-module_my-sm-auto__1Sg4p","mr-sm-auto":"MenuRoutes-module_mr-sm-auto__3fUi8","mx-sm-auto":"MenuRoutes-module_mx-sm-auto__YuEEs","mb-sm-auto":"MenuRoutes-module_mb-sm-auto__3HsYJ","ml-sm-auto":"MenuRoutes-module_ml-sm-auto__2HQUW","m-md-0":"MenuRoutes-module_m-md-0__22fKK","mt-md-0":"MenuRoutes-module_mt-md-0__CTJhp","my-md-0":"MenuRoutes-module_my-md-0__glF4o","mr-md-0":"MenuRoutes-module_mr-md-0__3Yp8l","mx-md-0":"MenuRoutes-module_mx-md-0__QgBid","mb-md-0":"MenuRoutes-module_mb-md-0__2Ujo4","ml-md-0":"MenuRoutes-module_ml-md-0__AbfW3","m-md-1":"MenuRoutes-module_m-md-1__MuZcy","mt-md-1":"MenuRoutes-module_mt-md-1__3unz6","my-md-1":"MenuRoutes-module_my-md-1__2NIKg","mr-md-1":"MenuRoutes-module_mr-md-1__Y4pLM","mx-md-1":"MenuRoutes-module_mx-md-1__PLXYc","mb-md-1":"MenuRoutes-module_mb-md-1__-vrzX","ml-md-1":"MenuRoutes-module_ml-md-1__2ikKf","m-md-2":"MenuRoutes-module_m-md-2__2v2ZL","mt-md-2":"MenuRoutes-module_mt-md-2__3UbJ0","my-md-2":"MenuRoutes-module_my-md-2__11tVa","mr-md-2":"MenuRoutes-module_mr-md-2__3J5VU","mx-md-2":"MenuRoutes-module_mx-md-2__3W0-N","mb-md-2":"MenuRoutes-module_mb-md-2__39d00","ml-md-2":"MenuRoutes-module_ml-md-2__7tTPd","m-md-3":"MenuRoutes-module_m-md-3__hta5a","mt-md-3":"MenuRoutes-module_mt-md-3__InkQS","my-md-3":"MenuRoutes-module_my-md-3__3gRP2","mr-md-3":"MenuRoutes-module_mr-md-3__32L-o","mx-md-3":"MenuRoutes-module_mx-md-3__1rn1v","mb-md-3":"MenuRoutes-module_mb-md-3__YfeKg","ml-md-3":"MenuRoutes-module_ml-md-3__1hAol","m-md-4":"MenuRoutes-module_m-md-4__Bi6fw","mt-md-4":"MenuRoutes-module_mt-md-4__33sEq","my-md-4":"MenuRoutes-module_my-md-4__3VhNX","mr-md-4":"MenuRoutes-module_mr-md-4__hPw8O","mx-md-4":"MenuRoutes-module_mx-md-4__3Wxv-","mb-md-4":"MenuRoutes-module_mb-md-4__3pRVR","ml-md-4":"MenuRoutes-module_ml-md-4__5bFvl","m-md-5":"MenuRoutes-module_m-md-5__2WjRD","mt-md-5":"MenuRoutes-module_mt-md-5__kRld3","my-md-5":"MenuRoutes-module_my-md-5__HWvPa","mr-md-5":"MenuRoutes-module_mr-md-5__2DwO8","mx-md-5":"MenuRoutes-module_mx-md-5__1Wzyz","mb-md-5":"MenuRoutes-module_mb-md-5__1vAdy","ml-md-5":"MenuRoutes-module_ml-md-5__32DmG","p-md-0":"MenuRoutes-module_p-md-0__wV_MZ","pt-md-0":"MenuRoutes-module_pt-md-0__1VuF6","py-md-0":"MenuRoutes-module_py-md-0__1RcLV","pr-md-0":"MenuRoutes-module_pr-md-0__1PF7l","px-md-0":"MenuRoutes-module_px-md-0__3_2eQ","pb-md-0":"MenuRoutes-module_pb-md-0__b-TC-","pl-md-0":"MenuRoutes-module_pl-md-0__3tjlI","p-md-1":"MenuRoutes-module_p-md-1__1bHu3","pt-md-1":"MenuRoutes-module_pt-md-1__2NWdA","py-md-1":"MenuRoutes-module_py-md-1__xH_vY","pr-md-1":"MenuRoutes-module_pr-md-1__2TiLf","px-md-1":"MenuRoutes-module_px-md-1__3vHcn","pb-md-1":"MenuRoutes-module_pb-md-1__3bFnK","pl-md-1":"MenuRoutes-module_pl-md-1__1mbl-","p-md-2":"MenuRoutes-module_p-md-2__ikTJ3","pt-md-2":"MenuRoutes-module_pt-md-2__1AYP7","py-md-2":"MenuRoutes-module_py-md-2__2QQk3","pr-md-2":"MenuRoutes-module_pr-md-2__152kX","px-md-2":"MenuRoutes-module_px-md-2__3fwLc","pb-md-2":"MenuRoutes-module_pb-md-2__2vl3h","pl-md-2":"MenuRoutes-module_pl-md-2__2LeWR","p-md-3":"MenuRoutes-module_p-md-3__2RBV2","pt-md-3":"MenuRoutes-module_pt-md-3__zCMts","py-md-3":"MenuRoutes-module_py-md-3__1iGz-","pr-md-3":"MenuRoutes-module_pr-md-3__2pX2E","px-md-3":"MenuRoutes-module_px-md-3__1TL-P","pb-md-3":"MenuRoutes-module_pb-md-3__3JQvw","pl-md-3":"MenuRoutes-module_pl-md-3__Ln00r","p-md-4":"MenuRoutes-module_p-md-4__14Ttb","pt-md-4":"MenuRoutes-module_pt-md-4__1dMcF","py-md-4":"MenuRoutes-module_py-md-4__1HUd0","pr-md-4":"MenuRoutes-module_pr-md-4__3BiLi","px-md-4":"MenuRoutes-module_px-md-4__XpuO5","pb-md-4":"MenuRoutes-module_pb-md-4__2cxGB","pl-md-4":"MenuRoutes-module_pl-md-4__1KBvM","p-md-5":"MenuRoutes-module_p-md-5__3VjEO","pt-md-5":"MenuRoutes-module_pt-md-5__1r9ZB","py-md-5":"MenuRoutes-module_py-md-5__35Woh","pr-md-5":"MenuRoutes-module_pr-md-5__3kEDr","px-md-5":"MenuRoutes-module_px-md-5__1WDwy","pb-md-5":"MenuRoutes-module_pb-md-5__3cyGe","pl-md-5":"MenuRoutes-module_pl-md-5__nUr2L","m-md-n1":"MenuRoutes-module_m-md-n1__18lZI","mt-md-n1":"MenuRoutes-module_mt-md-n1__1HQsN","my-md-n1":"MenuRoutes-module_my-md-n1__2tLJU","mr-md-n1":"MenuRoutes-module_mr-md-n1__2IJNb","mx-md-n1":"MenuRoutes-module_mx-md-n1__2rlqV","mb-md-n1":"MenuRoutes-module_mb-md-n1__1Lbja","ml-md-n1":"MenuRoutes-module_ml-md-n1__ERLS4","m-md-n2":"MenuRoutes-module_m-md-n2__2Pqfw","mt-md-n2":"MenuRoutes-module_mt-md-n2__rJ-r_","my-md-n2":"MenuRoutes-module_my-md-n2__1cTwn","mr-md-n2":"MenuRoutes-module_mr-md-n2__328tD","mx-md-n2":"MenuRoutes-module_mx-md-n2__1H5aw","mb-md-n2":"MenuRoutes-module_mb-md-n2__ENm1l","ml-md-n2":"MenuRoutes-module_ml-md-n2__20sj_","m-md-n3":"MenuRoutes-module_m-md-n3__3GZUn","mt-md-n3":"MenuRoutes-module_mt-md-n3__2OfXV","my-md-n3":"MenuRoutes-module_my-md-n3__2v_jM","mr-md-n3":"MenuRoutes-module_mr-md-n3__3ggRj","mx-md-n3":"MenuRoutes-module_mx-md-n3__1boH3","mb-md-n3":"MenuRoutes-module_mb-md-n3__3zQmH","ml-md-n3":"MenuRoutes-module_ml-md-n3__SzSt0","m-md-n4":"MenuRoutes-module_m-md-n4__GkZsY","mt-md-n4":"MenuRoutes-module_mt-md-n4__33M8l","my-md-n4":"MenuRoutes-module_my-md-n4__24EVa","mr-md-n4":"MenuRoutes-module_mr-md-n4__hCv-E","mx-md-n4":"MenuRoutes-module_mx-md-n4__25J2R","mb-md-n4":"MenuRoutes-module_mb-md-n4__3G3Sl","ml-md-n4":"MenuRoutes-module_ml-md-n4__2uBB9","m-md-n5":"MenuRoutes-module_m-md-n5__2a_II","mt-md-n5":"MenuRoutes-module_mt-md-n5__1-t2A","my-md-n5":"MenuRoutes-module_my-md-n5__1sJ90","mr-md-n5":"MenuRoutes-module_mr-md-n5__3xbAw","mx-md-n5":"MenuRoutes-module_mx-md-n5__18oRc","mb-md-n5":"MenuRoutes-module_mb-md-n5__ooUYD","ml-md-n5":"MenuRoutes-module_ml-md-n5__2_2BY","m-md-auto":"MenuRoutes-module_m-md-auto__1VOsW","mt-md-auto":"MenuRoutes-module_mt-md-auto__2k1lM","my-md-auto":"MenuRoutes-module_my-md-auto__3PmVY","mr-md-auto":"MenuRoutes-module_mr-md-auto__2hjtp","mx-md-auto":"MenuRoutes-module_mx-md-auto__nP9xJ","mb-md-auto":"MenuRoutes-module_mb-md-auto__1r-7Q","ml-md-auto":"MenuRoutes-module_ml-md-auto__1445F","m-lg-0":"MenuRoutes-module_m-lg-0__2V_9d","mt-lg-0":"MenuRoutes-module_mt-lg-0__2QCNB","my-lg-0":"MenuRoutes-module_my-lg-0__29me9","mr-lg-0":"MenuRoutes-module_mr-lg-0__1f9sV","mx-lg-0":"MenuRoutes-module_mx-lg-0__Z7Bcm","mb-lg-0":"MenuRoutes-module_mb-lg-0__3f2IU","ml-lg-0":"MenuRoutes-module_ml-lg-0__3MtuP","m-lg-1":"MenuRoutes-module_m-lg-1__1aGlh","mt-lg-1":"MenuRoutes-module_mt-lg-1__1EUd1","my-lg-1":"MenuRoutes-module_my-lg-1__2DP3r","mr-lg-1":"MenuRoutes-module_mr-lg-1__L9Qay","mx-lg-1":"MenuRoutes-module_mx-lg-1__2CETg","mb-lg-1":"MenuRoutes-module_mb-lg-1__2a95C","ml-lg-1":"MenuRoutes-module_ml-lg-1__2JF88","m-lg-2":"MenuRoutes-module_m-lg-2__du3mi","mt-lg-2":"MenuRoutes-module_mt-lg-2__1OP9y","my-lg-2":"MenuRoutes-module_my-lg-2__28jHX","mr-lg-2":"MenuRoutes-module_mr-lg-2__3VpbQ","mx-lg-2":"MenuRoutes-module_mx-lg-2__3AF15","mb-lg-2":"MenuRoutes-module_mb-lg-2__3Q4b2","ml-lg-2":"MenuRoutes-module_ml-lg-2__3i2rw","m-lg-3":"MenuRoutes-module_m-lg-3__5g6Nl","mt-lg-3":"MenuRoutes-module_mt-lg-3__vKKA6","my-lg-3":"MenuRoutes-module_my-lg-3__FC5VK","mr-lg-3":"MenuRoutes-module_mr-lg-3__20E5m","mx-lg-3":"MenuRoutes-module_mx-lg-3__1Rgw2","mb-lg-3":"MenuRoutes-module_mb-lg-3__2smaV","ml-lg-3":"MenuRoutes-module_ml-lg-3__3XGXf","m-lg-4":"MenuRoutes-module_m-lg-4__3YCbC","mt-lg-4":"MenuRoutes-module_mt-lg-4__3LjAn","my-lg-4":"MenuRoutes-module_my-lg-4__1OIuB","mr-lg-4":"MenuRoutes-module_mr-lg-4__3GOEH","mx-lg-4":"MenuRoutes-module_mx-lg-4__DhRKV","mb-lg-4":"MenuRoutes-module_mb-lg-4__bJ-Zl","ml-lg-4":"MenuRoutes-module_ml-lg-4__31LPo","m-lg-5":"MenuRoutes-module_m-lg-5__17tuE","mt-lg-5":"MenuRoutes-module_mt-lg-5__2PCGs","my-lg-5":"MenuRoutes-module_my-lg-5__1-pqa","mr-lg-5":"MenuRoutes-module_mr-lg-5__2vNmo","mx-lg-5":"MenuRoutes-module_mx-lg-5__Ue8Hf","mb-lg-5":"MenuRoutes-module_mb-lg-5__2t30F","ml-lg-5":"MenuRoutes-module_ml-lg-5__2Txua","p-lg-0":"MenuRoutes-module_p-lg-0__1hTLH","pt-lg-0":"MenuRoutes-module_pt-lg-0__31UpV","py-lg-0":"MenuRoutes-module_py-lg-0__2NoJs","pr-lg-0":"MenuRoutes-module_pr-lg-0__3uKUM","px-lg-0":"MenuRoutes-module_px-lg-0__1ucak","pb-lg-0":"MenuRoutes-module_pb-lg-0__2E07-","pl-lg-0":"MenuRoutes-module_pl-lg-0__2JXWY","p-lg-1":"MenuRoutes-module_p-lg-1__2536E","pt-lg-1":"MenuRoutes-module_pt-lg-1__z6CTr","py-lg-1":"MenuRoutes-module_py-lg-1__2aJH-","pr-lg-1":"MenuRoutes-module_pr-lg-1__SUhl2","px-lg-1":"MenuRoutes-module_px-lg-1__T8E9Q","pb-lg-1":"MenuRoutes-module_pb-lg-1__3Fvdv","pl-lg-1":"MenuRoutes-module_pl-lg-1__1Crcj","p-lg-2":"MenuRoutes-module_p-lg-2__3vctF","pt-lg-2":"MenuRoutes-module_pt-lg-2__HNExk","py-lg-2":"MenuRoutes-module_py-lg-2__r9lAM","pr-lg-2":"MenuRoutes-module_pr-lg-2__3ewjo","px-lg-2":"MenuRoutes-module_px-lg-2__3wDqE","pb-lg-2":"MenuRoutes-module_pb-lg-2__1u-1i","pl-lg-2":"MenuRoutes-module_pl-lg-2__eYxX6","p-lg-3":"MenuRoutes-module_p-lg-3__3JqST","pt-lg-3":"MenuRoutes-module_pt-lg-3__1FNzO","py-lg-3":"MenuRoutes-module_py-lg-3__30ZDv","pr-lg-3":"MenuRoutes-module_pr-lg-3__2v-as","px-lg-3":"MenuRoutes-module_px-lg-3__rZfuc","pb-lg-3":"MenuRoutes-module_pb-lg-3__17twP","pl-lg-3":"MenuRoutes-module_pl-lg-3__1uuaB","p-lg-4":"MenuRoutes-module_p-lg-4__ci-Qe","pt-lg-4":"MenuRoutes-module_pt-lg-4__1RcRh","py-lg-4":"MenuRoutes-module_py-lg-4__377_J","pr-lg-4":"MenuRoutes-module_pr-lg-4__3JDrJ","px-lg-4":"MenuRoutes-module_px-lg-4__2IgyG","pb-lg-4":"MenuRoutes-module_pb-lg-4__3ZhfB","pl-lg-4":"MenuRoutes-module_pl-lg-4__1TItm","p-lg-5":"MenuRoutes-module_p-lg-5__iGJeE","pt-lg-5":"MenuRoutes-module_pt-lg-5__19OQd","py-lg-5":"MenuRoutes-module_py-lg-5__27NRV","pr-lg-5":"MenuRoutes-module_pr-lg-5__14mQo","px-lg-5":"MenuRoutes-module_px-lg-5__2lzc7","pb-lg-5":"MenuRoutes-module_pb-lg-5__1zMTj","pl-lg-5":"MenuRoutes-module_pl-lg-5__25azC","m-lg-n1":"MenuRoutes-module_m-lg-n1__uBmL8","mt-lg-n1":"MenuRoutes-module_mt-lg-n1__1dn6I","my-lg-n1":"MenuRoutes-module_my-lg-n1__37hIT","mr-lg-n1":"MenuRoutes-module_mr-lg-n1__eKGxd","mx-lg-n1":"MenuRoutes-module_mx-lg-n1__2-2WU","mb-lg-n1":"MenuRoutes-module_mb-lg-n1__3YoiH","ml-lg-n1":"MenuRoutes-module_ml-lg-n1__3Ww5k","m-lg-n2":"MenuRoutes-module_m-lg-n2__125Mv","mt-lg-n2":"MenuRoutes-module_mt-lg-n2__26HQe","my-lg-n2":"MenuRoutes-module_my-lg-n2__1vEpr","mr-lg-n2":"MenuRoutes-module_mr-lg-n2__2jKW1","mx-lg-n2":"MenuRoutes-module_mx-lg-n2__3fi24","mb-lg-n2":"MenuRoutes-module_mb-lg-n2__3CVLI","ml-lg-n2":"MenuRoutes-module_ml-lg-n2__1a-7V","m-lg-n3":"MenuRoutes-module_m-lg-n3__21qUb","mt-lg-n3":"MenuRoutes-module_mt-lg-n3__ByyI4","my-lg-n3":"MenuRoutes-module_my-lg-n3__1A0La","mr-lg-n3":"MenuRoutes-module_mr-lg-n3__3u_yH","mx-lg-n3":"MenuRoutes-module_mx-lg-n3__38lwT","mb-lg-n3":"MenuRoutes-module_mb-lg-n3__oNt6w","ml-lg-n3":"MenuRoutes-module_ml-lg-n3__2B-AC","m-lg-n4":"MenuRoutes-module_m-lg-n4__1vjhj","mt-lg-n4":"MenuRoutes-module_mt-lg-n4__33kJD","my-lg-n4":"MenuRoutes-module_my-lg-n4__GlWs6","mr-lg-n4":"MenuRoutes-module_mr-lg-n4__3AEkc","mx-lg-n4":"MenuRoutes-module_mx-lg-n4__3_Loi","mb-lg-n4":"MenuRoutes-module_mb-lg-n4__1f_i-","ml-lg-n4":"MenuRoutes-module_ml-lg-n4__1NxvZ","m-lg-n5":"MenuRoutes-module_m-lg-n5__13w5-","mt-lg-n5":"MenuRoutes-module_mt-lg-n5__gU6_F","my-lg-n5":"MenuRoutes-module_my-lg-n5__1DNaG","mr-lg-n5":"MenuRoutes-module_mr-lg-n5__29e44","mx-lg-n5":"MenuRoutes-module_mx-lg-n5__262au","mb-lg-n5":"MenuRoutes-module_mb-lg-n5__Cemzr","ml-lg-n5":"MenuRoutes-module_ml-lg-n5__1-wcD","m-lg-auto":"MenuRoutes-module_m-lg-auto__3a8N2","mt-lg-auto":"MenuRoutes-module_mt-lg-auto__3LjXa","my-lg-auto":"MenuRoutes-module_my-lg-auto__2ftIZ","mr-lg-auto":"MenuRoutes-module_mr-lg-auto__E7RsS","mx-lg-auto":"MenuRoutes-module_mx-lg-auto__1RK5Q","mb-lg-auto":"MenuRoutes-module_mb-lg-auto__3RyFw","ml-lg-auto":"MenuRoutes-module_ml-lg-auto__18vVs","m-xl-0":"MenuRoutes-module_m-xl-0__3ImKB","mt-xl-0":"MenuRoutes-module_mt-xl-0__1iCIV","my-xl-0":"MenuRoutes-module_my-xl-0__1r9x5","mr-xl-0":"MenuRoutes-module_mr-xl-0__1BbEf","mx-xl-0":"MenuRoutes-module_mx-xl-0__2ob7V","mb-xl-0":"MenuRoutes-module_mb-xl-0__3480O","ml-xl-0":"MenuRoutes-module_ml-xl-0__uES4R","m-xl-1":"MenuRoutes-module_m-xl-1__256p7","mt-xl-1":"MenuRoutes-module_mt-xl-1__VKxgB","my-xl-1":"MenuRoutes-module_my-xl-1__1-k1P","mr-xl-1":"MenuRoutes-module_mr-xl-1__1IDrb","mx-xl-1":"MenuRoutes-module_mx-xl-1__2SNZ5","mb-xl-1":"MenuRoutes-module_mb-xl-1__qrFmh","ml-xl-1":"MenuRoutes-module_ml-xl-1__1x6Oe","m-xl-2":"MenuRoutes-module_m-xl-2__3XKyc","mt-xl-2":"MenuRoutes-module_mt-xl-2__2G1sN","my-xl-2":"MenuRoutes-module_my-xl-2__AapQV","mr-xl-2":"MenuRoutes-module_mr-xl-2__1BVZB","mx-xl-2":"MenuRoutes-module_mx-xl-2__nSdLC","mb-xl-2":"MenuRoutes-module_mb-xl-2__23wwX","ml-xl-2":"MenuRoutes-module_ml-xl-2__18Kf2","m-xl-3":"MenuRoutes-module_m-xl-3__2rQNN","mt-xl-3":"MenuRoutes-module_mt-xl-3__BDf4A","my-xl-3":"MenuRoutes-module_my-xl-3__UMEIq","mr-xl-3":"MenuRoutes-module_mr-xl-3__2TLFd","mx-xl-3":"MenuRoutes-module_mx-xl-3__3C9Kn","mb-xl-3":"MenuRoutes-module_mb-xl-3__29PDE","ml-xl-3":"MenuRoutes-module_ml-xl-3__3Hf5Q","m-xl-4":"MenuRoutes-module_m-xl-4__36nZK","mt-xl-4":"MenuRoutes-module_mt-xl-4__eMW0A","my-xl-4":"MenuRoutes-module_my-xl-4__19tG9","mr-xl-4":"MenuRoutes-module_mr-xl-4__3RH67","mx-xl-4":"MenuRoutes-module_mx-xl-4__1gly4","mb-xl-4":"MenuRoutes-module_mb-xl-4__2CIa3","ml-xl-4":"MenuRoutes-module_ml-xl-4__36D0n","m-xl-5":"MenuRoutes-module_m-xl-5__20hLO","mt-xl-5":"MenuRoutes-module_mt-xl-5__3LySp","my-xl-5":"MenuRoutes-module_my-xl-5__2Of57","mr-xl-5":"MenuRoutes-module_mr-xl-5__3oXhW","mx-xl-5":"MenuRoutes-module_mx-xl-5__1Okwz","mb-xl-5":"MenuRoutes-module_mb-xl-5__jlX5y","ml-xl-5":"MenuRoutes-module_ml-xl-5__16q_a","p-xl-0":"MenuRoutes-module_p-xl-0__3YP7L","pt-xl-0":"MenuRoutes-module_pt-xl-0__KCzRq","py-xl-0":"MenuRoutes-module_py-xl-0__1cfQJ","pr-xl-0":"MenuRoutes-module_pr-xl-0__3C6TW","px-xl-0":"MenuRoutes-module_px-xl-0__3V9y2","pb-xl-0":"MenuRoutes-module_pb-xl-0__1zou4","pl-xl-0":"MenuRoutes-module_pl-xl-0__1y8In","p-xl-1":"MenuRoutes-module_p-xl-1__21LCP","pt-xl-1":"MenuRoutes-module_pt-xl-1__2EBP3","py-xl-1":"MenuRoutes-module_py-xl-1__2ugq1","pr-xl-1":"MenuRoutes-module_pr-xl-1__1exHm","px-xl-1":"MenuRoutes-module_px-xl-1__2uZMR","pb-xl-1":"MenuRoutes-module_pb-xl-1__2K07G","pl-xl-1":"MenuRoutes-module_pl-xl-1__UPYdi","p-xl-2":"MenuRoutes-module_p-xl-2__2kJ7O","pt-xl-2":"MenuRoutes-module_pt-xl-2__MwHZQ","py-xl-2":"MenuRoutes-module_py-xl-2__3ApAo","pr-xl-2":"MenuRoutes-module_pr-xl-2__12zsS","px-xl-2":"MenuRoutes-module_px-xl-2__3diKq","pb-xl-2":"MenuRoutes-module_pb-xl-2__1Oac4","pl-xl-2":"MenuRoutes-module_pl-xl-2__2-XAE","p-xl-3":"MenuRoutes-module_p-xl-3__3FXzA","pt-xl-3":"MenuRoutes-module_pt-xl-3__3ox9V","py-xl-3":"MenuRoutes-module_py-xl-3__RBnmm","pr-xl-3":"MenuRoutes-module_pr-xl-3__1YkQM","px-xl-3":"MenuRoutes-module_px-xl-3__2_UuP","pb-xl-3":"MenuRoutes-module_pb-xl-3__1BZHM","pl-xl-3":"MenuRoutes-module_pl-xl-3__P-SlM","p-xl-4":"MenuRoutes-module_p-xl-4__qdbMA","pt-xl-4":"MenuRoutes-module_pt-xl-4__L1ct6","py-xl-4":"MenuRoutes-module_py-xl-4__21Nte","pr-xl-4":"MenuRoutes-module_pr-xl-4__26GmS","px-xl-4":"MenuRoutes-module_px-xl-4__1PHyN","pb-xl-4":"MenuRoutes-module_pb-xl-4__XyTy4","pl-xl-4":"MenuRoutes-module_pl-xl-4__20PfF","p-xl-5":"MenuRoutes-module_p-xl-5__3BXXA","pt-xl-5":"MenuRoutes-module_pt-xl-5__3xaOU","py-xl-5":"MenuRoutes-module_py-xl-5__28dCA","pr-xl-5":"MenuRoutes-module_pr-xl-5__2V24e","px-xl-5":"MenuRoutes-module_px-xl-5__8TtiI","pb-xl-5":"MenuRoutes-module_pb-xl-5__3kE9o","pl-xl-5":"MenuRoutes-module_pl-xl-5__1T1Yn","m-xl-n1":"MenuRoutes-module_m-xl-n1__3nGR0","mt-xl-n1":"MenuRoutes-module_mt-xl-n1__3iOJs","my-xl-n1":"MenuRoutes-module_my-xl-n1__jLSAP","mr-xl-n1":"MenuRoutes-module_mr-xl-n1__4FhYH","mx-xl-n1":"MenuRoutes-module_mx-xl-n1__34fEy","mb-xl-n1":"MenuRoutes-module_mb-xl-n1__SqSfA","ml-xl-n1":"MenuRoutes-module_ml-xl-n1__1jeVK","m-xl-n2":"MenuRoutes-module_m-xl-n2__1uEdg","mt-xl-n2":"MenuRoutes-module_mt-xl-n2__1Fnm7","my-xl-n2":"MenuRoutes-module_my-xl-n2__35Tgd","mr-xl-n2":"MenuRoutes-module_mr-xl-n2__2lffz","mx-xl-n2":"MenuRoutes-module_mx-xl-n2__QadjC","mb-xl-n2":"MenuRoutes-module_mb-xl-n2__A-GVz","ml-xl-n2":"MenuRoutes-module_ml-xl-n2__1V21G","m-xl-n3":"MenuRoutes-module_m-xl-n3__10Tc3","mt-xl-n3":"MenuRoutes-module_mt-xl-n3__3829V","my-xl-n3":"MenuRoutes-module_my-xl-n3__3x8q3","mr-xl-n3":"MenuRoutes-module_mr-xl-n3__2uQ_I","mx-xl-n3":"MenuRoutes-module_mx-xl-n3__2nu-N","mb-xl-n3":"MenuRoutes-module_mb-xl-n3__335Xs","ml-xl-n3":"MenuRoutes-module_ml-xl-n3__1p2eO","m-xl-n4":"MenuRoutes-module_m-xl-n4__2bntU","mt-xl-n4":"MenuRoutes-module_mt-xl-n4__3Zx20","my-xl-n4":"MenuRoutes-module_my-xl-n4__2X5lS","mr-xl-n4":"MenuRoutes-module_mr-xl-n4__1_ZJr","mx-xl-n4":"MenuRoutes-module_mx-xl-n4__1dvcF","mb-xl-n4":"MenuRoutes-module_mb-xl-n4__2BwCT","ml-xl-n4":"MenuRoutes-module_ml-xl-n4__1v_dE","m-xl-n5":"MenuRoutes-module_m-xl-n5__1ko_i","mt-xl-n5":"MenuRoutes-module_mt-xl-n5__Auq01","my-xl-n5":"MenuRoutes-module_my-xl-n5__qwpC3","mr-xl-n5":"MenuRoutes-module_mr-xl-n5__1FDHH","mx-xl-n5":"MenuRoutes-module_mx-xl-n5__3m8kU","mb-xl-n5":"MenuRoutes-module_mb-xl-n5__2oHqF","ml-xl-n5":"MenuRoutes-module_ml-xl-n5__3eJIY","m-xl-auto":"MenuRoutes-module_m-xl-auto__37Irw","mt-xl-auto":"MenuRoutes-module_mt-xl-auto__-v_6w","my-xl-auto":"MenuRoutes-module_my-xl-auto__3E8Z4","mr-xl-auto":"MenuRoutes-module_mr-xl-auto__2EmzC","mx-xl-auto":"MenuRoutes-module_mx-xl-auto__18ttj","mb-xl-auto":"MenuRoutes-module_mb-xl-auto__54KP5","ml-xl-auto":"MenuRoutes-module_ml-xl-auto__1zJSU","text-monospace":"MenuRoutes-module_text-monospace__3dkiV","text-justify":"MenuRoutes-module_text-justify__3qyop","text-wrap":"MenuRoutes-module_text-wrap__HTXKX","text-nowrap":"MenuRoutes-module_text-nowrap__2IGMP","text-truncate":"MenuRoutes-module_text-truncate__3OiP5","text-left":"MenuRoutes-module_text-left__1jwcG","text-right":"MenuRoutes-module_text-right__2mREx","text-center":"MenuRoutes-module_text-center__1RhRa","text-sm-left":"MenuRoutes-module_text-sm-left__37eve","text-sm-right":"MenuRoutes-module_text-sm-right__2LPeD","text-sm-center":"MenuRoutes-module_text-sm-center__1BuLn","text-md-left":"MenuRoutes-module_text-md-left__1bVnr","text-md-right":"MenuRoutes-module_text-md-right__2gtTs","text-md-center":"MenuRoutes-module_text-md-center__1ju7k","text-lg-left":"MenuRoutes-module_text-lg-left__3JUu1","text-lg-right":"MenuRoutes-module_text-lg-right__1t16Q","text-lg-center":"MenuRoutes-module_text-lg-center__2x1O7","text-xl-left":"MenuRoutes-module_text-xl-left__2z6Pa","text-xl-right":"MenuRoutes-module_text-xl-right__3m9G2","text-xl-center":"MenuRoutes-module_text-xl-center__1WDkH","text-lowercase":"MenuRoutes-module_text-lowercase__wmFyz","text-uppercase":"MenuRoutes-module_text-uppercase__1rMM6","text-capitalize":"MenuRoutes-module_text-capitalize__1OQsY","font-weight-light":"MenuRoutes-module_font-weight-light__3V2DN","font-weight-lighter":"MenuRoutes-module_font-weight-lighter__3rFeh","font-weight-normal":"MenuRoutes-module_font-weight-normal__2DCkJ","font-weight-bold":"MenuRoutes-module_font-weight-bold__1mLkL","font-weight-bolder":"MenuRoutes-module_font-weight-bolder__1ff7J","font-italic":"MenuRoutes-module_font-italic__1pBwo","text-white":"MenuRoutes-module_text-white__2hVba","text-primary":"MenuRoutes-module_text-primary__37sZC","text-secondary":"MenuRoutes-module_text-secondary__2bhvl","text-success":"MenuRoutes-module_text-success__3as2C","text-info":"MenuRoutes-module_text-info__2q-rx","text-warning":"MenuRoutes-module_text-warning__1XVNT","text-danger":"MenuRoutes-module_text-danger__2AGTk","text-light":"MenuRoutes-module_text-light__1Hkkx","text-dark":"MenuRoutes-module_text-dark__1J1OL","text-facebook":"MenuRoutes-module_text-facebook__-7biE","text-google":"MenuRoutes-module_text-google__3zN6z","text-body":"MenuRoutes-module_text-body__3-rKz","text-muted":"MenuRoutes-module_text-muted__2b7Uh","text-black-50":"MenuRoutes-module_text-black-50__hDJBw","text-white-50":"MenuRoutes-module_text-white-50__1lny7","text-hide":"MenuRoutes-module_text-hide__YHAwi","text-decoration-none":"MenuRoutes-module_text-decoration-none__1spBK","text-break":"MenuRoutes-module_text-break__3BCA3","text-reset":"MenuRoutes-module_text-reset__2bCjM","visible":"MenuRoutes-module_visible__3vcRI","invisible":"MenuRoutes-module_invisible__2ii0k","layoutContainer":"MenuRoutes-module_layoutContainer__1yhSf","backgroundImage":"MenuRoutes-module_backgroundImage__1Aoc1","headerClass":"MenuRoutes-module_headerClass__3SCOp","link":"MenuRoutes-module_link__v25wk","websiteLink":"MenuRoutes-module_websiteLink__2HZx7","headerIcon":"MenuRoutes-module_headerIcon__gcdEF","headerRight":"MenuRoutes-module_headerRight__3pbfb","accountLink":"MenuRoutes-module_accountLink__3lQRO","headerDescription":"MenuRoutes-module_headerDescription__3kz1j","loginButton":"MenuRoutes-module_loginButton__3UaeU","headerButton":"MenuRoutes-module_headerButton__2q2VK","login":"MenuRoutes-module_login__3dEnX","modalTopBorder":"MenuRoutes-module_modalTopBorder__3SPaL","banner":"MenuRoutes-module_banner__Rj54x","bannerAvatar":"MenuRoutes-module_bannerAvatar__1XmCC","mainContentArea":"MenuRoutes-module_mainContentArea__25WKS","inIFrame":"MenuRoutes-module_inIFrame__3yd32","mainContent":"MenuRoutes-module_mainContent__2Rr_5","menuHeader":"MenuRoutes-module_menuHeader__3jYcS","backIcon":"MenuRoutes-module_backIcon__YEoVY","withoutIcon":"MenuRoutes-module_withoutIcon__1g8LM","notificationHeader":"MenuRoutes-module_notificationHeader__2W6G5","mainMenuItem":"MenuRoutes-module_mainMenuItem__1aAsE","listItemFluid":"MenuRoutes-module_listItemFluid__3Q88M","deleteLinkItem":"MenuRoutes-module_deleteLinkItem__2OMcG","imgContainer":"MenuRoutes-module_imgContainer__39fsH","circle":"MenuRoutes-module_circle__3Kvuz","regularColor":"MenuRoutes-module_regularColor__WQ5Zx","emptyListItem":"MenuRoutes-module_emptyListItem__I2kUN","listTitle":"MenuRoutes-module_listTitle__3TBBH","menuDescription":"MenuRoutes-module_menuDescription__2vkzI","verificationWarning":"MenuRoutes-module_verificationWarning__25a8m","approveButtonGroup":"MenuRoutes-module_approveButtonGroup__1PmsZ","cancel":"MenuRoutes-module_cancel__2vhoa","button":"MenuRoutes-module_button__1HEIM","danger":"MenuRoutes-module_danger__1D8LW","secureText":"MenuRoutes-module_secureText__11m8A","hideWhileLoading":"MenuRoutes-module_hideWhileLoading__1ITi9","container":"MenuRoutes-module_container__sj3ew","menuContainer":"MenuRoutes-module_menuContainer__n7q4O","planOption":"MenuRoutes-module_planOption__3Kf-S","fullPadding":"MenuRoutes-module_fullPadding__MSmI6","accountHeader":"MenuRoutes-module_accountHeader__39kgR","navigationList":"MenuRoutes-module_navigationList__uftMM","donationDescription":"MenuRoutes-module_donationDescription__1db4m","donationSubmitButton":"MenuRoutes-module_donationSubmitButton__3BPgj","list":"MenuRoutes-module_list__3Ezg8","avatar":"MenuRoutes-module_avatar__2Yu9O","menuAvatar":"MenuRoutes-module_menuAvatar__3Jing","wrapper":"MenuRoutes-module_wrapper__1q03O","background":"MenuRoutes-module_background__2CvIt","notification":"MenuRoutes-module_notification__2Lm-A","noBg":"MenuRoutes-module_noBg__3OgRq","hoverCursorPointer":"MenuRoutes-module_hoverCursorPointer__3vkO4","verifyLink":"MenuRoutes-module_verifyLink__2divv","warningTooltipContainer":"MenuRoutes-module_warningTooltipContainer__3lnLQ","warningTooltip":"MenuRoutes-module_warningTooltip__2uy4q","warningTooltipIcon":"MenuRoutes-module_warningTooltipIcon__zjxzh"};

var WarnPaymentMethod = function WarnPaymentMethod(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Please update your payment method.' : _ref$label;
  return /*#__PURE__*/React__default['default'].createElement("span", null, /*#__PURE__*/React__default['default'].createElement(Tooltip__default['default'], {
    label: label,
    placement: "top",
    className: ""
  }, /*#__PURE__*/React__default['default'].createElement(Icon__default['default'], {
    icon: Icon.Icons.Warning,
    height: 18,
    width: 18
  })));
};

var Root = function Root(_ref2) {
  var Link = _ref2.Link,
      changeMenuRoute = _ref2.changeMenuRoute,
      currentPurchaseFailed = _ref2.currentPurchaseFailed,
      currentSubscriptionId = _ref2.currentSubscriptionId,
      currentSubscriptionTypeIsPass = _ref2.currentSubscriptionTypeIsPass,
      currentSubscriptionTypeIsRecurringDonation = _ref2.currentSubscriptionTypeIsRecurringDonation,
      currentSubscriptionTypeIsSubscription = _ref2.currentSubscriptionTypeIsSubscription,
      isGroupAdmin = _ref2.isGroupAdmin,
      isGroupMember = _ref2.isGroupMember,
      linkColor = _ref2.linkColor,
      monetizationIsPledge = _ref2.monetizationIsPledge,
      monetizationTypeIsDonation = _ref2.monetizationTypeIsDonation,
      monetizationTypeIsGroup = _ref2.monetizationTypeIsGroup,
      monetizationTypeIsPass = _ref2.monetizationTypeIsPass,
      pricingHasMonetization = _ref2.pricingHasMonetization,
      publisherName = _ref2.publisherName,
      router = _ref2.router,
      supportEmail = _ref2.supportEmail,
      updatePaymentMethodText = _ref2.updatePaymentMethodText,
      userAvatarUrl = _ref2.userAvatarUrl,
      userEmail = _ref2.userEmail,
      userHasCurrentPurchases = _ref2.userHasCurrentPurchases,
      userHasGroupData = _ref2.userHasGroupData,
      userInitials = _ref2.userInitials,
      userVerified = _ref2.userVerified,
      closeMenu = _ref2.closeMenu,
      sendExternalLink = _ref2.sendExternalLink,
      utmRootUrl = _ref2.utmRootUrl,
      queryOverride = _ref2.queryOverride;
  var _router$query = router.query;
  _router$query = _router$query === void 0 ? {} : _router$query;
  var company_slug = _router$query.company_slug;
  var contrastColor = functions.colors.getContrastColor(linkColor);
  var isGmail = userEmail && userEmail.length > 10 && userEmail.slice(-10) === '@gmail.com';
  var helpMailto = !reactDeviceDetect.isIOS && isGmail ? "https://mail.google.com/mail/u/0/?view=cm&fs=1&to=".concat(supportEmail) : "mailto:".concat(supportEmail);
  var currentSubscriptionIdIsGift = currentSubscriptionId === 'GIFT';
  return /*#__PURE__*/React__default['default'].createElement(MenuWrapper__default['default'], {
    publisherName: publisherName,
    sendExternalLink: sendExternalLink,
    utmRootUrl: utmRootUrl,
    queryOverride: queryOverride
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.container
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.menuContainer, style.fullPadding)
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.wrapper
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.accountHeader
  }, /*#__PURE__*/React__default['default'].createElement("h3", null, "My Account"), /*#__PURE__*/React__default['default'].createElement("h6", null, userEmail)), /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.menuAvatar
  }, /*#__PURE__*/React__default['default'].createElement(Avatar__default['default'], {
    email: userEmail,
    avatarUrl: userAvatarUrl,
    initials: userInitials,
    linkColor: linkColor,
    contrastColor: contrastColor,
    size: "64px"
  }))), !userVerified && /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.verificationWarning
  }, /*#__PURE__*/React__default['default'].createElement("span", null, "Please", ' ', /*#__PURE__*/React__default['default'].createElement(Link, {
    href: "/verify",
    as: '/verify'
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    className: style.verifyLink
  }, "verify")), ' ', "your account.")), /*#__PURE__*/React__default['default'].createElement("ul", {
    className: style.navigationList,
    style: {
      color: linkColor
    }
  }, /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem,
    onClick: function onClick() {
      changeMenuRoute('/editProfile');
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'user-icon')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Edit Profile")), /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem,
    onClick: function onClick() {
      changeMenuRoute('/manageNewsletters');
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'envelope-icon')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Manage Newsletters")), currentSubscriptionTypeIsSubscription && pricingHasMonetization && monetizationIsPledge && !currentSubscriptionIdIsGift && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem,
    onClick: function onClick() {
      changeMenuRoute('/managePlan/membership');
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'refresh-icon')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Manage Membership ", currentPurchaseFailed && /*#__PURE__*/React__default['default'].createElement(WarnPaymentMethod, null))), !userHasCurrentPurchases && pricingHasMonetization && monetizationIsPledge && pricingHasMonetization && !monetizationTypeIsGroup && (!userHasGroupData || userHasGroupData && !isGroupAdmin && !isGroupMember) && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem
  }, /*#__PURE__*/React__default['default'].createElement(Link, {
    href: "/checkout",
    as: '/checkout'
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    className: classNames__default['default'](style.button, style.danger),
    onClick: function onClick() {
      closeMenu();
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'refresh-icon')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Become a Member")))), currentSubscriptionTypeIsSubscription && currentSubscriptionIdIsGift && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem,
    onClick: function onClick() {
      changeMenuRoute('/managePlan/gift');
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'refresh-icon')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Manage Subscription")), (isGroupMember || currentSubscriptionTypeIsSubscription && pricingHasMonetization && !monetizationIsPledge && !currentSubscriptionIdIsGift) && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem,
    onClick: function onClick() {
      changeMenuRoute('/managePlan/subscription');
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'refresh-icon')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Manage Subscription ", currentPurchaseFailed && /*#__PURE__*/React__default['default'].createElement(WarnPaymentMethod, null))), !userHasCurrentPurchases && pricingHasMonetization && !monetizationTypeIsPass && pricingHasMonetization && !monetizationTypeIsDonation && pricingHasMonetization && !monetizationIsPledge && pricingHasMonetization && !monetizationTypeIsGroup && (!userHasGroupData || userHasGroupData && !isGroupAdmin && !isGroupMember) && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem
  }, /*#__PURE__*/React__default['default'].createElement(Link, {
    href: "/checkout",
    as: '/checkout'
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    className: classNames__default['default'](style.button, style.danger),
    onClick: function onClick() {
      closeMenu();
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'refresh-icon')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Subscribe")))), isGroupAdmin && !isGroupMember && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem
  }, /*#__PURE__*/React__default['default'].createElement(Link, {
    href: "/group",
    as: '/group'
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    className: classNames__default['default'](style.button, style.danger),
    onClick: function onClick() {
      closeMenu();
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'refresh-icon')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Join Group Subscription")))), currentSubscriptionTypeIsRecurringDonation && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem,
    onClick: function onClick() {
      changeMenuRoute('/managePlan/donation');
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'refresh-icon')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Manage Donation")), currentSubscriptionTypeIsPass && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem,
    onClick: function onClick() {
      changeMenuRoute('/managePlan/pass');
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'refresh-icon')), /*#__PURE__*/React__default['default'].createElement("h5", null, "View Pass")), !userHasCurrentPurchases && pricingHasMonetization && monetizationTypeIsPass && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem
  }, /*#__PURE__*/React__default['default'].createElement(Link, {
    href: "/checkout",
    as: '/checkout'
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    className: classNames__default['default'](style.button, style.danger),
    onClick: function onClick() {
      closeMenu();
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'refresh-icon')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Buy a Pass")))), !userHasCurrentPurchases && pricingHasMonetization && monetizationTypeIsDonation && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem
  }, /*#__PURE__*/React__default['default'].createElement(Link, {
    href: "/donate",
    as: '/donate'
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    className: classNames__default['default'](style.button, style.danger),
    onClick: function onClick() {
      closeMenu();
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'refresh-icon')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Donate")))), pricingHasMonetization && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem
  }, /*#__PURE__*/React__default['default'].createElement(Link, {
    href: "/gift",
    as: '/gift'
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    className: classNames__default['default'](style.button, style.danger),
    onClick: function onClick() {
      closeMenu();
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'gift-icon')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Give a Gift")))), supportEmail && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    onClick: function onClick(e) {
      e.preventDefault();

      if (sendExternalLink) {
        sendExternalLink(helpMailto);
      } else {
        window.open(helpMailto);
      }
    },
    href: helpMailto
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'question-mark-icon')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Help"))), /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem,
    onClick: function onClick() {
      changeMenuRoute('/logOut');
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'logout-icon')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Log Out"))))));
};

Root.defaultProps = {
  sendExternalLink: null,
  utmRootUrl: null
};
Root.propTypes = {
  changeMenuRoute: PropTypes__default['default'].func.isRequired,
  router: PropTypes__default['default'].shape({
    pathname: PropTypes__default['default'].string,
    query: PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      short_code: PropTypes__default['default'].string
    })
  }).isRequired,
  userEmail: PropTypes__default['default'].string.isRequired,
  sendExternalLink: PropTypes__default['default'].func,
  currentSubscriptionIdIsGift: PropTypes__default['default'].string,
  utmRootUrl: PropTypes__default['default'].string,
  queryOverride: PropTypes__default['default'].object
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var EditProfile = function EditProfile(_ref) {
  var _classNames, _classNames2;

  var changeMenuRoute = _ref.changeMenuRoute,
      userLoader = _ref.userLoader,
      guestLoader = _ref.guestLoader,
      router = _ref.router,
      userEmail = _ref.userEmail,
      userFullName = _ref.userFullName,
      Link = _ref.Link,
      userHasPassword = _ref.userHasPassword,
      sendExternalLink = _ref.sendExternalLink,
      utmRootUrl = _ref.utmRootUrl,
      queryOverride = _ref.queryOverride;
  var scopedLoader = userLoader || guestLoader || {};
  var _scopedLoader$publish = scopedLoader.publisher;
  _scopedLoader$publish = _scopedLoader$publish === void 0 ? {} : _scopedLoader$publish;
  var publisherName = _scopedLoader$publish.name,
      _scopedLoader$publish2 = _scopedLoader$publish.styling;
  _scopedLoader$publish2 = _scopedLoader$publish2 === void 0 ? {} : _scopedLoader$publish2;
  var _scopedLoader$publish3 = _scopedLoader$publish2.linkColor,
      linkColor = _scopedLoader$publish3 === void 0 ? '' : _scopedLoader$publish3;
  var _router$query = router.query;
  _router$query = _router$query === void 0 ? {} : _router$query;
  var company_slug = _router$query.company_slug;

  var _utmLink = functions.utmLink(Object.assign({}, queryOverride || (router === null || router === void 0 ? void 0 : router.query) || {}, {
    utmRootUrl: utmRootUrl
  })),
      trypico_link = _utmLink.trypico_link;

  return /*#__PURE__*/React__default['default'].createElement(MenuWrapper__default['default'], {
    publisherName: publisherName,
    sendExternalLink: sendExternalLink,
    utmRootUrl: utmRootUrl,
    queryOverride: queryOverride
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.menuHeader
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.backIcon,
    onClick: function onClick() {
      changeMenuRoute('/');
    },
    style: {
      color: linkColor
    }
  }, functions.getSvgImage(linkColor, 'back-icon')), /*#__PURE__*/React__default['default'].createElement("h3", null, "Edit Profile")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.container
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    className: style.secureText
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "icon-landing-page-case"
  }), "Your data is managed and secured by", ' ', /*#__PURE__*/React__default['default'].createElement("strong", null, /*#__PURE__*/React__default['default'].createElement("a", {
    href: trypico_link,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "\xA0Pico."))), /*#__PURE__*/React__default['default'].createElement("ul", {
    className: style.menuContainer,
    style: {
      color: linkColor
    }
  }, /*#__PURE__*/React__default['default'].createElement("li", {
    onClick: function onClick() {
      changeMenuRoute('/editProfile/editName');
    }
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    className: style.listTitle
  }, "Name"), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default']((_classNames = {}, _defineProperty(_classNames, style.emptyListItem, !userFullName), _defineProperty(_classNames, style.regularColor, userFullName), _classNames))
  }, userFullName || 'None'), functions.getSvgImage(linkColor, 'edit-icon'))), /*#__PURE__*/React__default['default'].createElement("li", {
    onClick: function onClick() {
      changeMenuRoute('/editProfile/editEmail');
    }
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    className: style.listTitle
  }, "Email Address"), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default']((_classNames2 = {}, _defineProperty(_classNames2, style.emptyListItem, !userEmail), _defineProperty(_classNames2, style.regularColor, userEmail), _classNames2))
  }, userEmail || 'None'), functions.getSvgImage(linkColor, 'edit-icon'))), /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem
  }, /*#__PURE__*/React__default['default'].createElement(Link, {
    href: "/account/edit-password",
    as: '/account/edit-password'
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%'
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("p", {
    className: style.listTitle
  }, "Password"), /*#__PURE__*/React__default['default'].createElement("h5", {
    className: style.emptyListItem
  }, userLoader && userHasPassword ? '*******' : 'None')), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, functions.getSvgImage(linkColor, 'edit-icon'))))), /*#__PURE__*/React__default['default'].createElement("li", {
    className: classNames__default['default'](style.mainMenuItem, style.deleteLinkItem)
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer)
  }, functions.getSvgImage('rgb(255, 94, 91)', 'trash-icon')), /*#__PURE__*/React__default['default'].createElement("h5", {
    onClick: function onClick() {
      changeMenuRoute('/editProfile/deleteAccount');
    }
  }, "Delete Account")))));
};

EditProfile.defaultProps = {
  sendExternalLink: null,
  utmRootUrl: null
};
EditProfile.propTypes = {
  changeMenuRoute: PropTypes__default['default'].func.isRequired,
  router: PropTypes__default['default'].shape({
    pathname: PropTypes__default['default'].string,
    query: PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      short_code: PropTypes__default['default'].string
    })
  }).isRequired,
  sendExternalLink: PropTypes__default['default'].func,
  utmRootUrl: PropTypes__default['default'].string,
  queryOverride: PropTypes__default['default'].object
};

var EditProfileEditName = function EditProfileEditName(_ref) {
  var account = _ref.account,
      publisherId = _ref.publisherId,
      changeMenuRoute = _ref.changeMenuRoute,
      userLoader = _ref.userLoader,
      guestLoader = _ref.guestLoader,
      router = _ref.router,
      WizardRedux = _ref.WizardRedux,
      updateLoaderUser = _ref.updateLoaderUser,
      initialize = _ref.initialize,
      update = _ref.update,
      utmRootUrl = _ref.utmRootUrl,
      queryOverride = _ref.queryOverride;
  var scopedLoader = userLoader || guestLoader || {};
  var _scopedLoader$publish = scopedLoader.publisher;
  _scopedLoader$publish = _scopedLoader$publish === void 0 ? {} : _scopedLoader$publish;
  var publisherName = _scopedLoader$publish.name,
      _scopedLoader$publish2 = _scopedLoader$publish.styling;
  _scopedLoader$publish2 = _scopedLoader$publish2 === void 0 ? {} : _scopedLoader$publish2;
  var _scopedLoader$publish3 = _scopedLoader$publish2.linkColor,
      linkColor = _scopedLoader$publish3 === void 0 ? '' : _scopedLoader$publish3;
  return /*#__PURE__*/React__default['default'].createElement(MenuWrapper__default['default'], {
    publisherName: publisherName,
    utmRootUrl: utmRootUrl,
    queryOverride: queryOverride
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.menuHeader
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.backIcon,
    onClick: function onClick() {
      changeMenuRoute('/editProfile');
    },
    style: {
      color: linkColor
    }
  }, functions.getSvgImage(linkColor, 'back-icon')), /*#__PURE__*/React__default['default'].createElement("h3", null, "Edit Name")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.container
  }, /*#__PURE__*/React__default['default'].createElement(Account__default['default'], {
    router: router,
    account: account,
    publisherId: publisherId,
    userLoader: userLoader,
    WizardRedux: WizardRedux,
    updateLoaderUser: updateLoaderUser,
    initialize: initialize,
    update: update,
    skipWizardSubmit: true,
    hasInDropdown: true,
    changeMenuRoute: changeMenuRoute,
    type: "name"
  })));
};

EditProfileEditName.defaultProps = {
  publisherId: null
};
EditProfileEditName.propTypes = {
  publisherId: PropTypes__default['default'].string,
  changeMenuRoute: PropTypes__default['default'].func.isRequired,
  utmRootUrl: PropTypes__default['default'].string,
  queryOverride: PropTypes__default['default'].object
};

var EditProfileEditEmail = function EditProfileEditEmail(_ref) {
  var publisherId = _ref.publisherId,
      changeMenuRoute = _ref.changeMenuRoute,
      userLoader = _ref.userLoader,
      guestLoader = _ref.guestLoader,
      account = _ref.account,
      router = _ref.router,
      WizardRedux = _ref.WizardRedux,
      update = _ref.update,
      initialize = _ref.initialize,
      onEmailChange = _ref.onEmailChange,
      utmRootUrl = _ref.utmRootUrl,
      queryOverride = _ref.queryOverride;
  var scopedLoader = userLoader || guestLoader || {};
  var _scopedLoader$publish = scopedLoader.publisher;
  _scopedLoader$publish = _scopedLoader$publish === void 0 ? {} : _scopedLoader$publish;
  var publisherName = _scopedLoader$publish.name,
      _scopedLoader$publish2 = _scopedLoader$publish.styling;
  _scopedLoader$publish2 = _scopedLoader$publish2 === void 0 ? {} : _scopedLoader$publish2;
  var _scopedLoader$publish3 = _scopedLoader$publish2.linkColor,
      linkColor = _scopedLoader$publish3 === void 0 ? '' : _scopedLoader$publish3;
  return /*#__PURE__*/React__default['default'].createElement(MenuWrapper__default['default'], {
    publisherName: publisherName,
    utmRootUrl: utmRootUrl,
    queryOverride: queryOverride
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.menuHeader
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.backIcon,
    onClick: function onClick() {
      changeMenuRoute('/editProfile');
    },
    style: {
      color: linkColor
    }
  }, functions.getSvgImage(linkColor, 'back-icon')), /*#__PURE__*/React__default['default'].createElement("h3", null, "Edit Email")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.container
  }, /*#__PURE__*/React__default['default'].createElement(Account__default['default'], {
    publisherId: publisherId,
    userLoader: userLoader,
    account: account,
    router: router,
    WizardRedux: WizardRedux,
    update: update,
    initialize: initialize,
    onEmailChange: onEmailChange,
    skipWizardSubmit: true,
    changeMenuRoute: changeMenuRoute,
    hasInDropdown: true,
    type: "email"
  })));
};

EditProfileEditEmail.defaultProps = {
  publisherId: null
};
EditProfileEditEmail.propTypes = {
  publisherId: PropTypes__default['default'].string,
  changeMenuRoute: PropTypes__default['default'].func.isRequired,
  account: PropTypes__default['default'].any.isRequired,
  userLoader: PropTypes__default['default'].any.isRequired,
  guestLoader: PropTypes__default['default'].any.isRequired,
  router: PropTypes__default['default'].any.isRequired,
  WizardRedux: PropTypes__default['default'].element.isRequired,
  update: PropTypes__default['default'].func.isRequired,
  initialize: PropTypes__default['default'].func.isRequired,
  onEmailChange: PropTypes__default['default'].func.isRequired,
  utmRootUrl: PropTypes__default['default'].string,
  queryOverride: PropTypes__default['default'].object
};

var EditProfileEditPassword = function EditProfileEditPassword(_ref) {
  var publisherId = _ref.publisherId,
      changeMenuRoute = _ref.changeMenuRoute,
      userLoader = _ref.userLoader,
      guestLoader = _ref.guestLoader,
      utmRootUrl = _ref.utmRootUrl,
      queryOverride = _ref.queryOverride;
  var scopedLoader = userLoader || guestLoader || {};
  var _scopedLoader$publish = scopedLoader.publisher;
  _scopedLoader$publish = _scopedLoader$publish === void 0 ? {} : _scopedLoader$publish;
  var publisherName = _scopedLoader$publish.name,
      _scopedLoader$publish2 = _scopedLoader$publish.styling;
  _scopedLoader$publish2 = _scopedLoader$publish2 === void 0 ? {} : _scopedLoader$publish2;
  var _scopedLoader$publish3 = _scopedLoader$publish2.linkColor,
      linkColor = _scopedLoader$publish3 === void 0 ? '' : _scopedLoader$publish3;
  return /*#__PURE__*/React__default['default'].createElement(MenuWrapper__default['default'], {
    publisherName: publisherName,
    utmRootUrl: utmRootUrl,
    queryOverride: queryOverride
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.menuHeader
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.backIcon,
    onClick: function onClick() {
      changeMenuRoute('/editProfile');
    },
    style: {
      color: linkColor
    }
  }, functions.getSvgImage(linkColor, 'back-icon')), /*#__PURE__*/React__default['default'].createElement("h3", null, "Edit Password")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.container
  }, /*#__PURE__*/React__default['default'].createElement(Account__default['default'], {
    publisherId: publisherId,
    userLoader: userLoader,
    skipWizardSubmit: true,
    hasInDropdown: true,
    type: "password"
  })));
};

EditProfileEditPassword.defaultProps = {
  publisherId: null
};
EditProfileEditPassword.propTypes = {
  publisherId: PropTypes__default['default'].string,
  changeMenuRoute: PropTypes__default['default'].func.isRequired,
  userLoader: PropTypes__default['default'].any.isRequired,
  guestLoader: PropTypes__default['default'].any.isRequired,
  utmRootUrl: PropTypes__default['default'].string,
  queryOverride: PropTypes__default['default'].object
};

var EditProfileDeleteAccount = function EditProfileDeleteAccount(_ref) {
  var changeMenuRoute = _ref.changeMenuRoute,
      deleteAccount = _ref.deleteAccount,
      publisherId = _ref.publisherId,
      userId = _ref.userId,
      accountDeleted = _ref.accountDeleted,
      router = _ref.router,
      userLoader = _ref.userLoader,
      guestLoader = _ref.guestLoader,
      utmRootUrl = _ref.utmRootUrl,
      queryOverride = _ref.queryOverride,
      _ref$canDeleteAccount = _ref.canDeleteAccount,
      canDeleteAccount = _ref$canDeleteAccount === void 0 ? true : _ref$canDeleteAccount;

  if (accountDeleted) {
    router.replace({
      pathname: '/logout'
    }, {
      pathname: '/logout'
    });
    return null;
  }

  var scopedLoader = userLoader || guestLoader || {};
  var _scopedLoader$publish = scopedLoader.publisher;
  _scopedLoader$publish = _scopedLoader$publish === void 0 ? {} : _scopedLoader$publish;
  var publisherName = _scopedLoader$publish.name,
      _scopedLoader$publish2 = _scopedLoader$publish.styling;
  _scopedLoader$publish2 = _scopedLoader$publish2 === void 0 ? {} : _scopedLoader$publish2;
  var _scopedLoader$publish3 = _scopedLoader$publish2.linkColor,
      linkColor = _scopedLoader$publish3 === void 0 ? '' : _scopedLoader$publish3;
  var messageText = canDeleteAccount ? "Are you sure you want to delete your account? ".concat(publisherName, " will no longer have access to any of your account information.") : 'Your account cannot be deleted, since you have a subscription that is still active.';
  return /*#__PURE__*/React__default['default'].createElement(MenuWrapper__default['default'], {
    publisherName: publisherName,
    utmRootUrl: utmRootUrl,
    queryOverride: queryOverride
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.menuHeader
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.backIcon,
    onClick: function onClick() {
      changeMenuRoute('/editProfile');
    },
    style: {
      color: linkColor
    }
  }, functions.getSvgImage(linkColor, 'back-icon')), /*#__PURE__*/React__default['default'].createElement("h3", null, "Delete Account")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.container
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.menuDescription
  }, /*#__PURE__*/React__default['default'].createElement("p", null, messageText)), canDeleteAccount ? /*#__PURE__*/React__default['default'].createElement("div", {
    "data-menu_route": "/logOut"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.approveButtonGroup
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    onClick: function onClick() {
      changeMenuRoute('/');
    },
    style: {
      color: linkColor
    },
    className: style.cancel
  }, "Cancel"), /*#__PURE__*/React__default['default'].createElement("span", {
    onClick: function onClick() {
      deleteAccount({
        userId: userId,
        publisherId: publisherId
      });
    }
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: classNames__default['default'](style.button, style.danger)
  }, "Delete Account")))) : null));
};

EditProfileDeleteAccount.propTypes = {
  changeMenuRoute: PropTypes__default['default'].func.isRequired,
  canDeleteAccount: PropTypes__default['default'].bool.isRequired,
  utmRootUrl: PropTypes__default['default'].string,
  queryOverride: PropTypes__default['default'].object
};

var Logout = function Logout(_ref) {
  var Link = _ref.Link,
      changeMenuRoute = _ref.changeMenuRoute,
      router = _ref.router,
      userLoader = _ref.userLoader,
      guestLoader = _ref.guestLoader,
      sendExternalLink = _ref.sendExternalLink,
      utmRootUrl = _ref.utmRootUrl,
      queryOverride = _ref.queryOverride;
  var scopedLoader = userLoader || guestLoader || {};
  var _scopedLoader$publish = scopedLoader.publisher;
  _scopedLoader$publish = _scopedLoader$publish === void 0 ? {} : _scopedLoader$publish;
  var publisherName = _scopedLoader$publish.name,
      _scopedLoader$publish2 = _scopedLoader$publish.styling;
  _scopedLoader$publish2 = _scopedLoader$publish2 === void 0 ? {} : _scopedLoader$publish2;
  var _scopedLoader$publish3 = _scopedLoader$publish2.linkColor,
      linkColor = _scopedLoader$publish3 === void 0 ? '' : _scopedLoader$publish3;
  var _router$query = router.query;
  _router$query = _router$query === void 0 ? {} : _router$query;
  var company_slug = _router$query.company_slug;
  return /*#__PURE__*/React__default['default'].createElement(MenuWrapper__default['default'], {
    publisherName: publisherName,
    sendExternalLink: sendExternalLink,
    utmRootUrl: utmRootUrl,
    queryOverride: queryOverride
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.menuHeader, style.withoutIcon)
  }, /*#__PURE__*/React__default['default'].createElement("h3", null, "Are you sure you want to log out?")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.container
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.menuDescription
  }, /*#__PURE__*/React__default['default'].createElement("p", null, "You may lose access to some content.")), /*#__PURE__*/React__default['default'].createElement("div", {
    "data-menu_route": "/logOut"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.approveButtonGroup
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    onClick: function onClick() {
      changeMenuRoute('/');
    },
    style: {
      color: linkColor
    },
    className: style.cancel
  }, "Cancel"), /*#__PURE__*/React__default['default'].createElement("span", null, /*#__PURE__*/React__default['default'].createElement(Link, {
    href: "/logout",
    as: '/logout'
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    className: classNames__default['default'](style.button, style.danger)
  }, "Log Out")))))));
};

Logout.defaultProps = {
  sendExternalLink: null,
  utmRootUrl: null
};
Logout.propTypes = {
  changeMenuRoute: PropTypes__default['default'].func.isRequired,
  router: PropTypes__default['default'].shape({
    pathname: PropTypes__default['default'].string,
    query: PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      short_code: PropTypes__default['default'].string
    })
  }).isRequired,
  sendExternalLink: PropTypes__default['default'].func,
  utmRootUrl: PropTypes__default['default'].string,
  queryOverride: PropTypes__default['default'].object
};

var ManageNewsletters = function ManageNewsletters(props) {
  var SelectNewsletters = props.SelectNewsletters,
      changeMenuRoute = props.changeMenuRoute,
      userLoader = props.userLoader,
      guestLoader = props.guestLoader,
      sendExternalLink = props.sendExternalLink,
      utmRootUrl = props.utmRootUrl,
      queryOverride = props.queryOverride;
  var scopedLoader = userLoader || guestLoader || {};
  var _scopedLoader$publish = scopedLoader.publisher;
  _scopedLoader$publish = _scopedLoader$publish === void 0 ? {} : _scopedLoader$publish;
  var publisherName = _scopedLoader$publish.name,
      _scopedLoader$publish2 = _scopedLoader$publish.styling;
  _scopedLoader$publish2 = _scopedLoader$publish2 === void 0 ? {} : _scopedLoader$publish2;
  var _scopedLoader$publish3 = _scopedLoader$publish2.linkColor,
      linkColor = _scopedLoader$publish3 === void 0 ? '' : _scopedLoader$publish3;
  return /*#__PURE__*/React__default['default'].createElement(MenuWrapper__default['default'], {
    publisherName: publisherName,
    sendExternalLink: sendExternalLink,
    utmRootUrl: utmRootUrl,
    queryOverride: queryOverride
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.menuHeader
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.backIcon,
    onClick: function onClick() {
      changeMenuRoute('/');
    },
    style: {
      color: linkColor
    }
  }, functions.getSvgImage(linkColor, 'back-icon')), /*#__PURE__*/React__default['default'].createElement("h3", null, "Manage Newsletters")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.container
  }, /*#__PURE__*/React__default['default'].createElement(SelectNewsletters, _extends({}, props, {
    skipWizardSubmit: true,
    containerType: "dropdown",
    onCancelClick: function onCancelClick() {
      changeMenuRoute('/');
    },
    showSyncOption: true,
    newsletterFilter: "all",
    isSingleColumn: true
  }))));
};

ManageNewsletters.defaultProps = {
  publisherId: null,
  sendExternalLink: null
};
ManageNewsletters.propTypes = {
  changeMenuRoute: PropTypes__default['default'].func.isRequired,
  publisherId: PropTypes__default['default'].string,
  sendExternalLink: PropTypes__default['default'].func,
  userLoader: PropTypes__default['default'].any.isRequired,
  guestLoader: PropTypes__default['default'].any.isRequired,
  utmRootUrl: PropTypes__default['default'].string,
  SelectNewsletters: PropTypes__default['default'].any,
  queryOverride: PropTypes__default['default'].object
};

var NotificationMenuPage = function NotificationMenuPage(props) {
  var backRoute = props.backRoute,
      changeMenuRoute = props.changeMenuRoute,
      linkColor = props.linkColor,
      publisherName = props.publisherName,
      _props$text = props.text,
      text = _props$text === void 0 ? '' : _props$text,
      sendExternalLink = props.sendExternalLink,
      utmRootUrl = props.utmRootUrl,
      queryOverride = props.queryOverride;
  return /*#__PURE__*/React__default['default'].createElement(MenuWrapper__default['default'], {
    publisherName: publisherName,
    sendExternalLink: sendExternalLink,
    queryOverride: queryOverride,
    utmRootUrl: utmRootUrl,
    hideBackground: true
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.menuHeader, style.shadow, style.notificationHeader)
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.backIcon,
    onClick: function onClick() {
      changeMenuRoute(!backRoute ? '/' : backRoute);
    },
    style: {
      color: linkColor
    }
  }, functions.getSvgImage(linkColor, 'back-icon')), /*#__PURE__*/React__default['default'].createElement("h3", null, "Notifications")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.background),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.notification
  }, text)));
};

NotificationMenuPage.propTypes = {
  sendExternalLink: null,
  utmRootUrl: null
};
NotificationMenuPage.propTypes = {
  changeMenuRoute: PropTypes__default['default'].func.isRequired,
  sendExternalLink: PropTypes__default['default'].func,
  utmRootUrl: PropTypes__default['default'].string,
  queryOverride: PropTypes__default['default'].object
};

var NotificationMenuPage$1 = function NotificationMenuPage(props) {
  var backRoute = props.backRoute,
      changeMenuRoute = props.changeMenuRoute,
      currentPlanOptionId = props.currentPlanOptionId,
      currentSubscriptionId = props.currentSubscriptionId,
      linkColor = props.linkColor,
      memberNoun = props.memberNoun,
      memberType = props.memberType,
      publisherId = props.publisherId,
      publisherName = props.publisherName,
      _props$data = props.data;
  _props$data = _props$data === void 0 ? {} : _props$data;
  var _props$data$nextDate = _props$data.nextDate,
      nextDate = _props$data$nextDate === void 0 ? '' : _props$data$nextDate,
      keepPlan = props.keepPlan,
      utmRootUrl = props.utmRootUrl,
      queryOverride = props.queryOverride;

  var KeepButton = function KeepButton(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/React__default['default'].createElement("strong", {
      className: style.hoverCursorPointer,
      onClick: function onClick() {
        keepPlan({
          planOptionId: currentPlanOptionId,
          publisherId: publisherId,
          subscriptionId: currentSubscriptionId
        });
      },
      style: {
        color: linkColor,
        textDecoration: 'underline'
      }
    }, children);
  };

  var descriptionText = memberType === 'donor' ? /*#__PURE__*/React__default['default'].createElement("span", null, "We're disappointed to see you end your support of great content on", ' ', publisherName, ". If you've changed your mind, please", ' ', /*#__PURE__*/React__default['default'].createElement(KeepButton, null, "click here"), ".") : /*#__PURE__*/React__default['default'].createElement("span", null, "You are now set to lose your current plan benefits on", ' ', nextDate, ".  ", ' ', /*#__PURE__*/React__default['default'].createElement(KeepButton, null, "Click here"), ' ', "to keep your", ' ', memberNoun, ' ', "instead.");
  return /*#__PURE__*/React__default['default'].createElement(MenuWrapper__default['default'], {
    publisherName: publisherName,
    utmRootUrl: utmRootUrl,
    queryOverride: queryOverride,
    hideBackground: true
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.menuHeader, style.shadow, style.notificationHeader)
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.backIcon,
    onClick: function onClick() {
      changeMenuRoute(!backRoute ? '/' : backRoute);
    },
    style: {
      color: linkColor
    }
  }, functions.getSvgImage(linkColor, 'back-icon')), /*#__PURE__*/React__default['default'].createElement("h3", null, "Notifications")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.background),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.notification
  }, descriptionText)));
};

NotificationMenuPage$1.defaultProps = {
  publisherId: null
};
NotificationMenuPage$1.propTypes = {
  changeMenuRoute: PropTypes__default['default'].func.isRequired,
  publisherId: PropTypes__default['default'].string,
  router: PropTypes__default['default'].shape({
    pathname: PropTypes__default['default'].string,
    query: PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      short_code: PropTypes__default['default'].string
    })
  }).isRequired,
  utmRootUrl: PropTypes__default['default'].string,
  queryOverride: PropTypes__default['default'].object
};

var NotificationMenuPage$2 = function NotificationMenuPage(props) {
  var backRoute = props.backRoute,
      changeMenuRoute = props.changeMenuRoute,
      linkColor = props.linkColor,
      memberNoun = props.memberNoun,
      nextPlanSubscriptionEnd = props.nextPlanSubscriptionEnd,
      nextPlanPlanOptionPrice = props.nextPlanPlanOptionPrice,
      utmRootUrl = props.utmRootUrl,
      queryOverride = props.queryOverride,
      currentPlanOptionCurrency = props.currentPlanOptionCurrency;
  var descriptionText = /*#__PURE__*/React__default['default'].createElement("p", null, "Thank you, your ", memberNoun, " will now continue uninterrupted. It will next renew on ", moment__default['default'](nextPlanSubscriptionEnd).format('LL'), " for ".concat(currency__default['default'].format({
    amount: nextPlanPlanOptionPrice,
    currencyCode: currentPlanOptionCurrency,
    symbol: true
  })));
  return /*#__PURE__*/React__default['default'].createElement(MenuWrapper__default['default'], {
    utmRootUrl: utmRootUrl,
    queryOverride: queryOverride,
    hideBackground: true
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.menuHeader, style.shadow, style.notificationHeader)
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.backIcon,
    onClick: function onClick() {
      changeMenuRoute(!backRoute ? '/' : backRoute);
    },
    style: {
      color: linkColor
    }
  }, functions.getSvgImage(linkColor, 'back-icon')), /*#__PURE__*/React__default['default'].createElement("h3", null, "Notifications")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.background),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.notification
  }, descriptionText)));
};

NotificationMenuPage$2.propTypes = {
  changeMenuRoute: PropTypes__default['default'].func.isRequired,
  utmRootUrl: PropTypes__default['default'].string,
  queryOverride: PropTypes__default['default'].object,
  backRoute: PropTypes__default['default'].string,
  linkColor: PropTypes__default['default'].string.isRequired,
  memberNoun: PropTypes__default['default'].string.isRequired,
  nextPlanSubscriptionEnd: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number]).isRequired,
  nextPlanPlanOptionPrice: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number]).isRequired
};

var NotificationMenuPage$3 = function NotificationMenuPage(props) {
  var backRoute = props.backRoute,
      data = props.data,
      changeMenuRoute = props.changeMenuRoute,
      linkColor = props.linkColor,
      nextPlan = props.nextPlan,
      nextPlanSubscriptionEnd = props.nextPlanSubscriptionEnd,
      nextPlanPlanOptionPrice = props.nextPlanPlanOptionPrice,
      nextPlanPlanOptionInterval = props.nextPlanPlanOptionInterval,
      publisherName = props.publisherName,
      utmRootUrl = props.utmRootUrl,
      queryOverride = props.queryOverride;

  var _ref = data || {},
      switchNow = _ref.switchNow;

  var nextPaymentStart = (nextPlan === null || nextPlan === void 0 ? void 0 : nextPlan.subscription_start) || nextPlanSubscriptionEnd;
  var descriptionText = switchNow ? "Your plan will switch to ".concat(nextPlanPlanOptionPrice, "/").concat(nextPlanPlanOptionInterval, " on ").concat(moment__default['default'](nextPlanSubscriptionEnd).format('LL'), ".") : "Your plan has been successfully updated. Your next payment is scheduled for ".concat(moment__default['default'](nextPaymentStart).format('LL'), ".");
  return /*#__PURE__*/React__default['default'].createElement(MenuWrapper__default['default'], {
    publisherName: publisherName,
    utmRootUrl: utmRootUrl,
    queryOverride: queryOverride,
    hideBackground: true
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.menuHeader, style.shadow, style.notificationHeader)
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.backIcon,
    onClick: function onClick() {
      changeMenuRoute(!backRoute ? '/' : backRoute);
    },
    style: {
      color: linkColor
    }
  }, functions.getSvgImage(linkColor, 'back-icon')), /*#__PURE__*/React__default['default'].createElement("h3", null, "Notifications")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.background),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.notification
  }, descriptionText)));
};

NotificationMenuPage$3.defaultProps = {
  publisherId: null
};
NotificationMenuPage$3.propTypes = {
  changeMenuRoute: PropTypes__default['default'].func.isRequired,
  publisherId: PropTypes__default['default'].string,
  router: PropTypes__default['default'].shape({
    pathname: PropTypes__default['default'].string,
    query: PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      short_code: PropTypes__default['default'].string
    })
  }).isRequired,
  utmRootUrl: PropTypes__default['default'].string,
  nextPlan: PropTypes__default['default'].any,
  queryOverride: PropTypes__default['default'].object
};

var ManagePlan = function ManagePlan(_ref) {
  var changeMenuRoute = _ref.changeMenuRoute,
      userLoader = _ref.userLoader,
      guestLoader = _ref.guestLoader,
      sendExternalLink = _ref.sendExternalLink,
      utmRootUrl = _ref.utmRootUrl,
      queryOverride = _ref.queryOverride;
  var scopedLoader = userLoader || guestLoader || {};
  var _scopedLoader$publish = scopedLoader.publisher;
  _scopedLoader$publish = _scopedLoader$publish === void 0 ? {} : _scopedLoader$publish;
  var publisherName = _scopedLoader$publish.name,
      _scopedLoader$publish2 = _scopedLoader$publish.styling;
  _scopedLoader$publish2 = _scopedLoader$publish2 === void 0 ? {} : _scopedLoader$publish2;
  var _scopedLoader$publish3 = _scopedLoader$publish2.linkColor,
      linkColor = _scopedLoader$publish3 === void 0 ? '' : _scopedLoader$publish3;
  return /*#__PURE__*/React__default['default'].createElement(MenuWrapper__default['default'], {
    publisherName: publisherName,
    sendExternalLink: sendExternalLink,
    utmRootUrl: utmRootUrl,
    queryOverride: queryOverride
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.menuHeader
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.backIcon,
    onClick: function onClick() {
      changeMenuRoute('/');
    },
    style: {
      color: linkColor
    }
  }, functions.getSvgImage(linkColor, 'back-icon')), /*#__PURE__*/React__default['default'].createElement("h3", null, "Manage Plan")), /*#__PURE__*/React__default['default'].createElement("ul", {
    style: {
      color: linkColor
    }
  }, /*#__PURE__*/React__default['default'].createElement("li", {
    onClick: function onClick() {
      changeMenuRoute('/managePlan/subscription');
    }
  }, "Subscription"), /*#__PURE__*/React__default['default'].createElement("li", {
    onClick: function onClick() {
      changeMenuRoute('/managePlan/subscription/finished');
    }
  }, "Stopped Subscription"), /*#__PURE__*/React__default['default'].createElement("li", {
    onClick: function onClick() {
      changeMenuRoute('/managePlan/donation');
    }
  }, "Reccuring Donation"), /*#__PURE__*/React__default['default'].createElement("li", {
    onClick: function onClick() {
      changeMenuRoute('/managePlan/pass');
    }
  }, "Pass"), /*#__PURE__*/React__default['default'].createElement("li", {
    onClick: function onClick() {
      changeMenuRoute('/managePlan/gift');
    }
  }, "Gift")));
};

ManagePlan.propTypes = {
  sendExternalLink: null,
  utmRootUrl: null
};
ManagePlan.propTypes = {
  changeMenuRoute: PropTypes__default['default'].func.isRequired,
  sendExternalLink: PropTypes__default['default'].func,
  utmRootUrl: PropTypes__default['default'].string,
  guestLoader: PropTypes__default['default'].any,
  userLoader: PropTypes__default['default'].any,
  queryOverride: PropTypes__default['default'].object
};

var ManagePlanCancelPlan = function ManagePlanCancelPlan(_ref) {
  var changeMenuRoute = _ref.changeMenuRoute,
      userLoader = _ref.userLoader,
      guestLoader = _ref.guestLoader,
      utmRootUrl = _ref.utmRootUrl,
      queryOverride = _ref.queryOverride;
  var scopedLoader = userLoader || guestLoader || {};
  var _scopedLoader$publish = scopedLoader.publisher;
  _scopedLoader$publish = _scopedLoader$publish === void 0 ? {} : _scopedLoader$publish;
  var publisherName = _scopedLoader$publish.name,
      _scopedLoader$publish2 = _scopedLoader$publish.styling;
  _scopedLoader$publish2 = _scopedLoader$publish2 === void 0 ? {} : _scopedLoader$publish2;
  var _scopedLoader$publish3 = _scopedLoader$publish2.linkColor,
      linkColor = _scopedLoader$publish3 === void 0 ? '' : _scopedLoader$publish3;
  return /*#__PURE__*/React__default['default'].createElement(MenuWrapper__default['default'], {
    publisherName: publisherName,
    utmRootUrl: utmRootUrl,
    queryOverride: queryOverride
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.menuHeader
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.backIcon,
    onClick: function onClick() {
      changeMenuRoute('/maganePlan');
    },
    style: {
      color: linkColor
    }
  }, functions.getSvgImage(linkColor, 'back-icon')), /*#__PURE__*/React__default['default'].createElement("h3", null, "Cancel Plan")));
};

ManagePlanCancelPlan.propTypes = {
  changeMenuRoute: PropTypes__default['default'].func.isRequired,
  utmRootUrl: PropTypes__default['default'].string,
  userLoader: PropTypes__default['default'].any.isRequired,
  guestLoader: PropTypes__default['default'].any.isRequired,
  queryOverride: PropTypes__default['default'].object
};

var ManagePlanDonation = function ManagePlanDonation(_ref) {
  var Link = _ref.Link,
      changeMenuRoute = _ref.changeMenuRoute,
      currentBillingIntervalTotalPaid = _ref.currentBillingIntervalTotalPaid,
      currentSubscriptionStart = _ref.currentSubscriptionStart,
      currentPlanOptionId = _ref.currentPlanOptionId,
      currentSubscriptionId = _ref.currentSubscriptionId,
      publisherId = _ref.publisherId,
      closeMenu = _ref.closeMenu,
      firstDonation = _ref.firstDonation,
      nextPlanPlanOptionPrice = _ref.nextPlanPlanOptionPrice,
      nextPlanSubscriptionStart = _ref.nextPlanSubscriptionStart,
      nextPlanSubscriptionEnd = _ref.nextPlanSubscriptionEnd,
      nextPlanStatusNext = _ref.nextPlanStatusNext,
      userLoader = _ref.userLoader,
      guestLoader = _ref.guestLoader,
      currentPurchaseCanceled = _ref.currentPurchaseCanceled,
      keepPlan = _ref.keepPlan,
      currentPlanOptionCurrency = _ref.currentPlanOptionCurrency,
      nextPlan = _ref.nextPlan,
      utmRootUrl = _ref.utmRootUrl,
      queryOverride = _ref.queryOverride;
  var scopedLoader = userLoader || guestLoader || {};
  var _scopedLoader$publish = scopedLoader.publisher;
  _scopedLoader$publish = _scopedLoader$publish === void 0 ? {} : _scopedLoader$publish;
  var publisherName = _scopedLoader$publish.name,
      _scopedLoader$publish2 = _scopedLoader$publish.styling;
  _scopedLoader$publish2 = _scopedLoader$publish2 === void 0 ? {} : _scopedLoader$publish2;
  var _scopedLoader$publish3 = _scopedLoader$publish2.linkColor,
      linkColor = _scopedLoader$publish3 === void 0 ? '' : _scopedLoader$publish3;
  var nextPaymentDate = nextPlanStatusNext ? nextPlanSubscriptionStart : nextPlanSubscriptionEnd;
  var isNotCancelled = !currentPurchaseCanceled || currentPurchaseCanceled && nextPlanStatusNext;
  return /*#__PURE__*/React__default['default'].createElement(MenuWrapper__default['default'], {
    publisherName: publisherName,
    utmRootUrl: utmRootUrl,
    queryOverride: queryOverride
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.menuHeader
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.backIcon,
    onClick: function onClick() {
      changeMenuRoute('/');
    },
    style: {
      color: linkColor
    }
  }, functions.getSvgImage(linkColor, 'back-icon')), /*#__PURE__*/React__default['default'].createElement("h3", null, "Manage Donation")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.container
  }, /*#__PURE__*/React__default['default'].createElement("ul", {
    className: style.menuContainer,
    style: {
      color: linkColor,
      borderBottom: '1px solid #ddd'
    }
  }, /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.list
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    className: style.listTitle
  }, "Donor Since"), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default'](style.regularColor)
  }, moment__default['default'](firstDonation).format('LL')))), /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.list
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    className: style.listTitle
  }, "".concat(isNotCancelled ? 'Last' : 'Final', " Donation")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default'](style.regularColor)
  }, "".concat(currency__default['default'].format({
    amount: currentBillingIntervalTotalPaid,
    currencyCode: currentPlanOptionCurrency,
    symbol: true
  }), " on ").concat(moment__default['default'](currentSubscriptionStart).format('LL'))))), isNotCancelled && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.list
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    className: style.listTitle
  }, "Next Donation"), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default'](style.regularColor)
  }, "".concat(currency__default['default'].format({
    amount: nextPlanPlanOptionPrice,
    currencyCode: nextPlan === null || nextPlan === void 0 ? void 0 : nextPlan.plan_option_currency,
    symbol: true
  }), " on ").concat(moment__default['default'](nextPaymentDate).format('LL'))))), !isNotCancelled && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.list
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default'](style.regularColor)
  }, "Your support is set to end on", ' ', /*#__PURE__*/React__default['default'].createElement("strong", null, moment__default['default'](nextPlanSubscriptionEnd).format('LL')))))), /*#__PURE__*/React__default['default'].createElement("ul", {
    className: classNames__default['default'](style.menuContainer, style.planOption),
    style: {
      color: linkColor
    }
  }, isNotCancelled && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem,
    onClick: function onClick() {
      changeMenuRoute('/managePlan/donation/change');
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      borderRadius: '4px',
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'switch-plan')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Change Donation Amount")), isNotCancelled && /*#__PURE__*/React__default['default'].createElement(Link, {
    href: "/cards/select",
    as: '/cards/select'
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    onClick: function onClick() {
      closeMenu();
    }
  }, /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      borderRadius: '4px',
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'update-payment')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Update Payment Method")))), isNotCancelled && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem,
    onClick: function onClick() {
      changeMenuRoute('/managePlan/subscription/stopSubscription');
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      borderRadius: '4px'
    }
  }, functions.getSvgImage('#FF5E5B', 'close-icon')), /*#__PURE__*/React__default['default'].createElement("h5", {
    style: {
      color: '#FF5E5B'
    }
  }, "Stop Contributing")), !isNotCancelled && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem,
    onClick: function onClick() {
      keepPlan({
        planOptionId: currentPlanOptionId,
        publisherId: publisherId,
        subscriptionId: currentSubscriptionId
      });
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'keep-icon')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Resume Monthly Donation")))));
};

ManagePlanDonation.defaultProps = {};
ManagePlanDonation.propTypes = {
  changeMenuRoute: PropTypes__default['default'].func.isRequired,
  nextPlan: PropTypes__default['default'].shape({
    plan_option_currency: PropTypes__default['default'].string.isRequired
  }).isRequired,
  currentPlanOptionCurrency: PropTypes__default['default'].string.isRequired,
  utmRootUrl: PropTypes__default['default'].string,
  queryOverride: PropTypes__default['default'].object
};

var ManagePlanDonationChange = function ManagePlanDonationChange(_ref) {
  var currentSubscriptionEnd = _ref.currentSubscriptionEnd,
      publisherId = _ref.publisherId,
      changeMenuRoute = _ref.changeMenuRoute,
      userLoader = _ref.userLoader,
      guestLoader = _ref.guestLoader,
      router = _ref.router,
      purchaseSwitch = _ref.purchaseSwitch,
      utmRootUrl = _ref.utmRootUrl,
      queryOverride = _ref.queryOverride,
      getPlanTexts = _ref.getPlanTexts,
      featureList = _ref.featureList,
      Link = _ref.Link,
      WizardRedux = _ref.WizardRedux,
      SelectDonation = _ref.SelectDonation,
      isFetching = _ref.isFetching,
      onDonationChangeSuccess = _ref.onDonationChangeSuccess;
  var scopedLoader = userLoader || guestLoader || {};
  var _scopedLoader$publish = scopedLoader.publisher;
  _scopedLoader$publish = _scopedLoader$publish === void 0 ? {} : _scopedLoader$publish;
  var publisherName = _scopedLoader$publish.name,
      _scopedLoader$publish2 = _scopedLoader$publish.styling;
  _scopedLoader$publish2 = _scopedLoader$publish2 === void 0 ? {} : _scopedLoader$publish2;
  var _scopedLoader$publish3 = _scopedLoader$publish2.linkColor,
      linkColor = _scopedLoader$publish3 === void 0 ? '' : _scopedLoader$publish3;
  var contrastColor = functions.colors.getContrastColor(linkColor);

  var Something = function Something(_ref2) {
    var form = _ref2.form;
    return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", {
      className: style.donationDescription
    }, /*#__PURE__*/React__default['default'].createElement("span", null, "Any change to your monthly donation will take effect on", ' ', moment__default['default'](currentSubscriptionEnd).format('LL'))), /*#__PURE__*/React__default['default'].createElement("div", {
      className: style.approveButtonGroup
    }, /*#__PURE__*/React__default['default'].createElement("span", {
      onClick: function onClick() {
        changeMenuRoute('/managePlan/donation');
      },
      style: {
        color: linkColor
      },
      className: style.cancel
    }, "Cancel"), /*#__PURE__*/React__default['default'].createElement("span", {
      onClick: function onClick() {
        form.submit();
      },
      className: style.donationSubmitButton,
      style: {
        backgroundColor: linkColor,
        color: contrastColor
      }
    }, "Update Amount")));
  };

  return /*#__PURE__*/React__default['default'].createElement(MenuWrapper__default['default'], {
    publisherName: publisherName,
    utmRootUrl: utmRootUrl,
    queryOverride: queryOverride
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.menuHeader
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.backIcon,
    onClick: function onClick() {
      changeMenuRoute('/managePlan/donation');
    },
    style: {
      color: linkColor
    }
  }, functions.getSvgImage(linkColor, 'back-icon')), /*#__PURE__*/React__default['default'].createElement("h3", null, "Change Donation Amount")), /*#__PURE__*/React__default['default'].createElement(SelectDonation, {
    userLoader: userLoader,
    router: router,
    hideCallToAction: true,
    hideToggle: true,
    toggleDefault: "recurring-donation",
    getFormSubmission: function getFormSubmission(_ref3) {
      var planOptionId = _ref3.plan_option_id,
          customPrice = _ref3.custom_price;
      purchaseSwitch(Object.assign({
        planOptionId: planOptionId,
        publisherId: publisherId
      }, customPrice && {
        customPrice: customPrice
      }));
    },
    onDonationChangeSuccess: onDonationChangeSuccess,
    hideFormSubmit: true,
    isChangingDonation: true,
    getPlanTexts: getPlanTexts,
    featureList: featureList,
    Link: Link,
    WizardRedux: WizardRedux,
    isFetching: isFetching
  }, /*#__PURE__*/React__default['default'].createElement(Something, null)));
};

ManagePlanDonationChange.defaultProps = {
  accessToken: null,
  publisherId: null
};
ManagePlanDonationChange.propTypes = {
  changeMenuRoute: PropTypes__default['default'].func.isRequired,
  publisherId: PropTypes__default['default'].string,
  accessToken: PropTypes__default['default'].string,
  router: PropTypes__default['default'].shape({
    pathname: PropTypes__default['default'].string,
    query: PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      short_code: PropTypes__default['default'].string
    })
  }).isRequired,
  utmRootUrl: PropTypes__default['default'].string,
  queryOverride: PropTypes__default['default'].object,
  Link: PropTypes__default['default'].object.isRequired,
  WizardRedux: PropTypes__default['default'].object.isRequired,
  SelectDonation: PropTypes__default['default'].func,
  isFetching: PropTypes__default['default'].bool,
  onDonationChangeSuccess: PropTypes__default['default'].func
};

var ManagePlanGift = function ManagePlanGift(_ref) {
  var changeMenuRoute = _ref.changeMenuRoute,
      currentSubscriptionEnd = _ref.currentSubscriptionEnd,
      currentSubscriptionPlanTierTitle = _ref.currentSubscriptionPlanTierTitle,
      userLoader = _ref.userLoader,
      guestLoader = _ref.guestLoader,
      _ref$convertGift = _ref.convertGift,
      convertGift = _ref$convertGift === void 0 ? function () {} : _ref$convertGift,
      utmRootUrl = _ref.utmRootUrl,
      queryOverride = _ref.queryOverride;
  var scopedLoader = userLoader || guestLoader || {};
  var _scopedLoader$publish = scopedLoader.publisher;
  _scopedLoader$publish = _scopedLoader$publish === void 0 ? {} : _scopedLoader$publish;
  var publisherName = _scopedLoader$publish.name,
      _scopedLoader$publish2 = _scopedLoader$publish.styling;
  _scopedLoader$publish2 = _scopedLoader$publish2 === void 0 ? {} : _scopedLoader$publish2;
  var _scopedLoader$publish3 = _scopedLoader$publish2.linkColor,
      linkColor = _scopedLoader$publish3 === void 0 ? '' : _scopedLoader$publish3;
  return /*#__PURE__*/React__default['default'].createElement(MenuWrapper__default['default'], {
    publisherName: publisherName,
    utmRootUrl: utmRootUrl,
    queryOverride: queryOverride
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.menuHeader
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.backIcon,
    onClick: function onClick() {
      changeMenuRoute('/');
    },
    style: {
      color: linkColor
    }
  }, functions.getSvgImage(linkColor, 'back-icon')), /*#__PURE__*/React__default['default'].createElement("h3", null, "Manage Subscription")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.container
  }, /*#__PURE__*/React__default['default'].createElement("ul", {
    className: style.menuContainer,
    style: {
      color: linkColor,
      borderBottom: '1px solid #ddd'
    }
  }, /*#__PURE__*/React__default['default'].createElement("li", null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default'](style.regularColor)
  }, "Your gift gives you access to ", currentSubscriptionPlanTierTitle, " until ", /*#__PURE__*/React__default['default'].createElement("strong", null, moment__default['default'](currentSubscriptionEnd).format('LL')))))), /*#__PURE__*/React__default['default'].createElement("ul", {
    className: classNames__default['default'](style.menuContainer, style.planOption),
    style: {
      color: linkColor
    }
  }, /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem,
    onClick: function onClick() {
      convertGift();
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'keep-icon')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Keep Subscription")))));
};

ManagePlanGift.propTypes = {
  changeMenuRoute: PropTypes__default['default'].func.isRequired,
  currentSubscriptionEnd: PropTypes__default['default'].string.isRequired,
  currentSubscriptionPlanTierTitle: PropTypes__default['default'].string.isRequired,
  convertGift: PropTypes__default['default'].func,
  userLoader: PropTypes__default['default'].any,
  guestLoader: PropTypes__default['default'].any,
  utmRootUrl: PropTypes__default['default'].string,
  queryOverride: PropTypes__default['default'].object
};

var ManagePlanMembership = function ManagePlanMembership(_ref) {
  var Link = _ref.Link,
      changeMenuRoute = _ref.changeMenuRoute,
      currentBillingIntervalTotalPaid = _ref.currentBillingIntervalTotalPaid,
      currentPlanOptionId = _ref.currentPlanOptionId,
      currentPlanOptionCurrency = _ref.currentPlanOptionCurrency,
      currentPurchaseCanceled = _ref.currentPurchaseCanceled,
      currentSubscriptionId = _ref.currentSubscriptionId,
      currentSubscriptionStart = _ref.currentSubscriptionStart,
      keepPlan = _ref.keepPlan,
      nextPlan = _ref.nextPlan,
      nextPlanPlanOptionPrice = _ref.nextPlanPlanOptionPrice,
      nextPlanStatusNext = _ref.nextPlanStatusNext,
      nextPlanSubscriptionEnd = _ref.nextPlanSubscriptionEnd,
      nextPlanSubscriptionStart = _ref.nextPlanSubscriptionStart,
      originalEnrollmentDate = _ref.originalEnrollmentDate,
      userLoader = _ref.userLoader,
      guestLoader = _ref.guestLoader,
      publisherId = _ref.publisherId,
      router = _ref.router,
      closeMenu = _ref.closeMenu,
      utmRootUrl = _ref.utmRootUrl,
      queryOverride = _ref.queryOverride;
  var scopedLoader = userLoader || guestLoader || {};
  var _scopedLoader$publish = scopedLoader.publisher;
  _scopedLoader$publish = _scopedLoader$publish === void 0 ? {} : _scopedLoader$publish;
  var publisherName = _scopedLoader$publish.name,
      _scopedLoader$publish2 = _scopedLoader$publish.styling;
  _scopedLoader$publish2 = _scopedLoader$publish2 === void 0 ? {} : _scopedLoader$publish2;
  var _scopedLoader$publish3 = _scopedLoader$publish2.linkColor,
      linkColor = _scopedLoader$publish3 === void 0 ? '' : _scopedLoader$publish3;
  var _router$query = router.query;
  _router$query = _router$query === void 0 ? {} : _router$query;
  var company_slug = _router$query.company_slug;
  var isWhitelistedReader = currentSubscriptionId === 'WHITELIST';
  var nextPaymentDate = nextPlanStatusNext ? nextPlanSubscriptionStart : nextPlanSubscriptionEnd;
  return /*#__PURE__*/React__default['default'].createElement(MenuWrapper__default['default'], {
    publisherName: publisherName,
    utmRootUrl: utmRootUrl,
    queryOverride: queryOverride
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.menuHeader
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.backIcon,
    onClick: function onClick() {
      changeMenuRoute('/');
    },
    style: {
      color: linkColor
    }
  }, functions.getSvgImage(linkColor, 'back-icon')), /*#__PURE__*/React__default['default'].createElement("h3", null, "Manage Membership")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.container
  }, /*#__PURE__*/React__default['default'].createElement("ul", {
    className: style.menuContainer,
    style: {
      color: linkColor,
      borderBottom: '1px solid #ddd'
    }
  }, isWhitelistedReader && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.list
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default'](style.regularColor)
  }, "You have access to ", publisherName, " until", ' ', /*#__PURE__*/React__default['default'].createElement("strong", null, moment__default['default'](nextPlanSubscriptionEnd).format('LL'))))), !isWhitelistedReader && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.list
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    className: style.listTitle
  }, "Membership Since"), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default'](style.regularColor)
  }, moment__default['default'](originalEnrollmentDate).format('LL')))), !isWhitelistedReader && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.list
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    className: style.listTitle
  }, "Last Payment"), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default'](style.regularColor)
  }, "".concat(currency__default['default'].format({
    amount: currentBillingIntervalTotalPaid,
    currencyCode: currentPlanOptionCurrency,
    symbol: true
  }), " on ").concat(moment__default['default'](currentSubscriptionStart).format('LL'))))), !isWhitelistedReader && (!currentPurchaseCanceled || currentPurchaseCanceled && nextPlanStatusNext) && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.list
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    className: style.listTitle
  }, "Next Payment"), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default'](style.regularColor)
  }, "".concat(currency__default['default'].format({
    amount: nextPlanPlanOptionPrice !== (nextPlan === null || nextPlan === void 0 ? void 0 : nextPlan.subscription_price) ? nextPlan === null || nextPlan === void 0 ? void 0 : nextPlan.subscription_price : nextPlanPlanOptionPrice,
    currencyCode: nextPlan === null || nextPlan === void 0 ? void 0 : nextPlan.plan_option_currency,
    symbol: true
  }), " on ").concat(moment__default['default'](nextPaymentDate).format('LL'))))), !isWhitelistedReader && currentPurchaseCanceled && (!nextPlan || !nextPlanStatusNext) && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.list
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default'](style.regularColor)
  }, "Your subscription is set to end on", ' ', /*#__PURE__*/React__default['default'].createElement("strong", null, moment__default['default'](nextPlanSubscriptionEnd).format('LL')))))), /*#__PURE__*/React__default['default'].createElement("ul", {
    className: classNames__default['default'](style.menuContainer, style.planOption),
    style: {
      color: linkColor
    }
  }, !isWhitelistedReader && (!currentPurchaseCanceled || currentPurchaseCanceled && nextPlanStatusNext) && /*#__PURE__*/React__default['default'].createElement(Link, {
    href: "/checkout",
    as: '/checkout'
  }, /*#__PURE__*/React__default['default'].createElement("a", null, /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      borderRadius: '4px',
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'switch-plan')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Switch Plan")))), !isWhitelistedReader && (!currentPurchaseCanceled || currentPurchaseCanceled && nextPlanStatusNext) && /*#__PURE__*/React__default['default'].createElement(Link, {
    href: "/cards/select",
    as: '/cards/select'
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    onClick: function onClick() {
      closeMenu();
    }
  }, /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      borderRadius: '4px',
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'update-payment')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Update Payment Method")))), !isWhitelistedReader && (!currentPurchaseCanceled || currentPurchaseCanceled && nextPlanStatusNext) && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem,
    onClick: function onClick() {
      changeMenuRoute('/managePlan/subscription/stopSubscription');
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      borderRadius: '4px'
    }
  }, functions.getSvgImage('#FF5E5B', 'close-icon')), /*#__PURE__*/React__default['default'].createElement("h5", {
    style: {
      color: '#FF5E5B'
    }
  }, "Stop Membership")), !isWhitelistedReader && currentPurchaseCanceled && (!nextPlan || !nextPlanStatusNext) && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem,
    onClick: function onClick() {
      keepPlan({
        planOptionId: currentPlanOptionId,
        publisherId: publisherId,
        subscriptionId: currentSubscriptionId
      });
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'keep-icon')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Keep Subscription")))));
};

ManagePlanMembership.defaultProps = {
  publisherId: null
};
ManagePlanMembership.propTypes = {
  changeMenuRoute: PropTypes__default['default'].func.isRequired,
  publisherId: PropTypes__default['default'].string,
  router: PropTypes__default['default'].shape({
    pathname: PropTypes__default['default'].string,
    query: PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      short_code: PropTypes__default['default'].string
    })
  }).isRequired,
  nextPlan: PropTypes__default['default'].shape({
    plan_option_currency: PropTypes__default['default'].string.isRequired,
    subscription_start: PropTypes__default['default'].string
  }).isRequired,
  currentPlanOptionCurrency: PropTypes__default['default'].string.isRequired,
  utmRootUrl: PropTypes__default['default'].string,
  queryOverride: PropTypes__default['default'].object
};

var ManagePlanPass = function ManagePlanPass(_ref) {
  var changeMenuRoute = _ref.changeMenuRoute,
      currentBillingIntervalTotalPaid = _ref.currentBillingIntervalTotalPaid,
      currentSubscriptionEnd = _ref.currentSubscriptionEnd,
      currentSubscriptionStart = _ref.currentSubscriptionStart,
      userLoader = _ref.userLoader,
      guestLoader = _ref.guestLoader,
      currentPlanOptionCurrency = _ref.currentPlanOptionCurrency,
      utmRootUrl = _ref.utmRootUrl,
      queryOverride = _ref.queryOverride;
  var scopedLoader = userLoader || guestLoader || {};
  var _scopedLoader$publish = scopedLoader.publisher;
  _scopedLoader$publish = _scopedLoader$publish === void 0 ? {} : _scopedLoader$publish;
  var publisherName = _scopedLoader$publish.name,
      _scopedLoader$publish2 = _scopedLoader$publish.styling;
  _scopedLoader$publish2 = _scopedLoader$publish2 === void 0 ? {} : _scopedLoader$publish2;
  var _scopedLoader$publish3 = _scopedLoader$publish2.linkColor,
      linkColor = _scopedLoader$publish3 === void 0 ? '' : _scopedLoader$publish3;
  return /*#__PURE__*/React__default['default'].createElement(MenuWrapper__default['default'], {
    publisherName: publisherName,
    utmRootUrl: utmRootUrl,
    queryOverride: queryOverride
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.menuHeader
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.backIcon,
    onClick: function onClick() {
      changeMenuRoute('/');
    },
    style: {
      color: linkColor
    }
  }, functions.getSvgImage(linkColor, 'back-icon')), /*#__PURE__*/React__default['default'].createElement("h3", null, "My Pass")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.container
  }, /*#__PURE__*/React__default['default'].createElement("ul", {
    className: style.menuContainer,
    style: {
      color: linkColor,
      borderBottom: '1px solid #ddd'
    }
  }, /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.list
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    className: style.listTitle
  }, "PASS START DATE"), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default'](style.regularColor)
  }, moment__default['default'](currentSubscriptionStart).format('LL')))), /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.list
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    className: style.listTitle
  }, "FINAL PAYMENT"), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default'](style.regularColor)
  }, "".concat(currency__default['default'].format({
    amount: currentBillingIntervalTotalPaid,
    currencyCode: currentPlanOptionCurrency,
    symbol: true
  }), " on ").concat(moment__default['default'](currentSubscriptionStart).format('LL'))))), /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.list
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default'](style.regularColor)
  }, "Your pass is set to end on", ' ', /*#__PURE__*/React__default['default'].createElement("strong", null, moment__default['default'](currentSubscriptionEnd).format('LL'))))))));
};

ManagePlanPass.propTypes = {
  changeMenuRoute: PropTypes__default['default'].func.isRequired,
  utmRootUrl: PropTypes__default['default'].string,
  currentPlanOptionCurrency: PropTypes__default['default'].any,
  queryOverride: PropTypes__default['default'].object
};

var ManagePlanSwitchPlan = function ManagePlanSwitchPlan(_ref) {
  var Link = _ref.Link,
      changeMenuRoute = _ref.changeMenuRoute,
      userLoader = _ref.userLoader,
      guestLoader = _ref.guestLoader,
      router = _ref.router,
      utmRootUrl = _ref.utmRootUrl,
      queryOverride = _ref.queryOverride;
  var scopedLoader = userLoader || guestLoader || {};
  var _scopedLoader$publish = scopedLoader.publisher;
  _scopedLoader$publish = _scopedLoader$publish === void 0 ? {} : _scopedLoader$publish;
  var publisherName = _scopedLoader$publish.name,
      _scopedLoader$publish2 = _scopedLoader$publish.styling;
  _scopedLoader$publish2 = _scopedLoader$publish2 === void 0 ? {} : _scopedLoader$publish2;
  var _scopedLoader$publish3 = _scopedLoader$publish2.linkColor,
      linkColor = _scopedLoader$publish3 === void 0 ? '' : _scopedLoader$publish3;
  var _router$query = router.query;
  _router$query = _router$query === void 0 ? {} : _router$query;
  var company_slug = _router$query.company_slug;
  var contrastColor = functions.colors.getContrastColor(linkColor);
  return /*#__PURE__*/React__default['default'].createElement(MenuWrapper__default['default'], {
    publisherName: publisherName,
    utmRootUrl: utmRootUrl,
    queryOverride: queryOverride
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.menuHeader
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.backIcon,
    onClick: function onClick() {
      changeMenuRoute('/');
    },
    style: {
      color: linkColor
    }
  }, functions.getSvgImage(linkColor, 'back-icon')), /*#__PURE__*/React__default['default'].createElement("h3", null, "Log Out")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.menuDescription
  }, /*#__PURE__*/React__default['default'].createElement("span", null, "You may lose access to some content.")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.approveButtonGroup
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    onClick: function onClick() {
      changeMenuRoute('/');
    },
    style: {
      color: linkColor
    },
    className: style.cancel
  }, "Cancel"), /*#__PURE__*/React__default['default'].createElement("span", null, /*#__PURE__*/React__default['default'].createElement(Link, {
    href: "/logout",
    as: '/logout'
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    className: style.button,
    style: {
      backgroundColor: linkColor,
      color: contrastColor
    }
  }, "Log Out")))));
};

ManagePlanSwitchPlan.defaultProps = {};
ManagePlanSwitchPlan.propTypes = {
  changeMenuRoute: PropTypes__default['default'].func.isRequired,
  router: PropTypes__default['default'].shape({
    pathname: PropTypes__default['default'].string,
    query: PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      short_code: PropTypes__default['default'].string
    })
  }).isRequired,
  utmRootUrl: PropTypes__default['default'].string,
  queryOverride: PropTypes__default['default'].object
};

var ManagePlanSubscription = function ManagePlanSubscription(_ref) {
  var _userLoader$group;

  var Link = _ref.Link,
      changeMenuRoute = _ref.changeMenuRoute,
      currentBillingIntervalTotalPaid = _ref.currentBillingIntervalTotalPaid,
      currentPlanOptionId = _ref.currentPlanOptionId,
      currentPurchaseCanceled = _ref.currentPurchaseCanceled,
      currentSubscriptionStart = _ref.currentSubscriptionStart,
      nextPlanSubscriptionStart = _ref.nextPlanSubscriptionStart,
      nextPlanSubscriptionEnd = _ref.nextPlanSubscriptionEnd,
      currentSubscriptionIsTrial = _ref.currentSubscriptionIsTrial,
      nextPlanStatusNext = _ref.nextPlanStatusNext,
      currentSubscriptionId = _ref.currentSubscriptionId,
      nextPlanPlanOptionPrice = _ref.nextPlanPlanOptionPrice,
      originalEnrollmentDate = _ref.originalEnrollmentDate,
      userLoader = _ref.userLoader,
      guestLoader = _ref.guestLoader,
      publisherId = _ref.publisherId,
      router = _ref.router,
      closeMenu = _ref.closeMenu,
      keepPlan = _ref.keepPlan,
      currentPlanOptionCurrency = _ref.currentPlanOptionCurrency,
      nextPlan = _ref.nextPlan,
      utmRootUrl = _ref.utmRootUrl,
      queryOverride = _ref.queryOverride,
      isGroupMember = _ref.isGroupMember,
      pubPriceChangeDate = _ref.pubPriceChangeDate;
  var scopedLoader = userLoader || guestLoader || {};
  var _scopedLoader$publish = scopedLoader.publisher;
  _scopedLoader$publish = _scopedLoader$publish === void 0 ? {} : _scopedLoader$publish;
  var publisherName = _scopedLoader$publish.name,
      _scopedLoader$publish2 = _scopedLoader$publish.styling;
  _scopedLoader$publish2 = _scopedLoader$publish2 === void 0 ? {} : _scopedLoader$publish2;
  var _scopedLoader$publish3 = _scopedLoader$publish2.linkColor,
      linkColor = _scopedLoader$publish3 === void 0 ? '' : _scopedLoader$publish3;
  var _router$query = router.query;
  _router$query = _router$query === void 0 ? {} : _router$query;
  var company_slug = _router$query.company_slug;
  var isWhitelistedReader = currentSubscriptionId === 'WHITELIST';
  var nextPaymentDate = nextPlanStatusNext ? nextPlanSubscriptionStart : nextPlanSubscriptionEnd;
  var planTierTitle = nextPlan === null || nextPlan === void 0 ? void 0 : nextPlan.plan_tier_title;
  var isPayingIndividual = !isWhitelistedReader && !isGroupMember;
  var groupName = userLoader === null || userLoader === void 0 ? void 0 : (_userLoader$group = userLoader.group) === null || _userLoader$group === void 0 ? void 0 : _userLoader$group.name;
  var isNotCancelled = !currentPurchaseCanceled || currentPurchaseCanceled && nextPlanStatusNext;
  return /*#__PURE__*/React__default['default'].createElement(MenuWrapper__default['default'], {
    publisherName: publisherName,
    utmRootUrl: utmRootUrl,
    queryOverride: queryOverride
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.menuHeader
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.backIcon,
    onClick: function onClick() {
      changeMenuRoute('/');
    },
    style: {
      color: linkColor
    }
  }, functions.getSvgImage(linkColor, 'back-icon')), /*#__PURE__*/React__default['default'].createElement("h3", null, "Manage Subscription")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.container
  }, /*#__PURE__*/React__default['default'].createElement("ul", {
    className: style.menuContainer,
    style: {
      color: linkColor,
      borderBottom: '1px solid #ddd'
    }
  }, isWhitelistedReader && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.list
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default'](style.regularColor)
  }, "You have access to ", planTierTitle || publisherName, " until", ' ', /*#__PURE__*/React__default['default'].createElement("strong", null, moment__default['default'](nextPlanSubscriptionEnd).format('LL'))))), isGroupMember && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.list
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default'](style.regularColor)
  }, "You have access to ", publisherName, " provided by", ' ', /*#__PURE__*/React__default['default'].createElement("strong", null, groupName), ". Please contact your group administrator to learn more."))), isPayingIndividual && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.list
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    className: style.listTitle
  }, "Subscriber Since"), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default'](style.regularColor)
  }, moment__default['default'](originalEnrollmentDate).format('LL')))), isPayingIndividual && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.list
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    className: style.listTitle
  }, "".concat(isNotCancelled ? 'Last' : 'Final', " Payment")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default'](style.regularColor)
  }, "".concat(currency__default['default'].format({
    amount: currentBillingIntervalTotalPaid,
    currencyCode: currentPlanOptionCurrency,
    symbol: true
  }), " on ").concat(moment__default['default'](currentSubscriptionStart).format('LL'))))), isPayingIndividual && isNotCancelled && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.list
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    className: style.listTitle
  }, "Next Payment"), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default'](style.regularColor, style.warningTooltipContainer)
  }, /*#__PURE__*/React__default['default'].createElement("span", null, "".concat(currency__default['default'].format({
    amount: nextPlanPlanOptionPrice,
    currencyCode: nextPlan === null || nextPlan === void 0 ? void 0 : nextPlan.plan_option_currency,
    symbol: true
  }), " on ").concat(moment__default['default'](nextPaymentDate).format('LL'))), isPayingIndividual && isNotCancelled && nextPlanPlanOptionPrice !== currentBillingIntervalTotalPaid && !currentSubscriptionIsTrial ? /*#__PURE__*/React__default['default'].createElement("span", {
    className: style.warningTooltip
  }, /*#__PURE__*/React__default['default'].createElement(Tooltip__default['default'], {
    label: "The price of a subscription changed on ".concat(moment__default['default'](pubPriceChangeDate, 'X').format('LL')),
    placement: "top"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    style: {
      color: linkColor
    },
    className: classNames__default['default']('icon-info', style.warningTooltipIcon)
  }))) : null))), isPayingIndividual && !isNotCancelled && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.list
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default'](style.regularColor)
  }, "Your subscription is set to end on", ' ', /*#__PURE__*/React__default['default'].createElement("strong", null, moment__default['default'](nextPlanSubscriptionEnd).format('LL')))))), /*#__PURE__*/React__default['default'].createElement("ul", {
    className: classNames__default['default'](style.menuContainer, style.planOption),
    style: {
      color: linkColor
    }
  }, isPayingIndividual && isNotCancelled && /*#__PURE__*/React__default['default'].createElement(Link, {
    href: "/checkout",
    as: '/checkout'
  }, /*#__PURE__*/React__default['default'].createElement("a", null, /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      borderRadius: '4px',
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'switch-plan')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Switch Plan")))), isPayingIndividual && isNotCancelled && /*#__PURE__*/React__default['default'].createElement(Link, {
    href: "/cards/select",
    as: '/cards/select'
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    onClick: function onClick() {
      closeMenu();
    }
  }, /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      borderRadius: '4px',
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'update-payment')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Update Payment Method")))), isPayingIndividual && isNotCancelled && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem,
    onClick: function onClick() {
      changeMenuRoute('/managePlan/subscription/stopSubscription');
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      borderRadius: '4px'
    }
  }, functions.getSvgImage('#FF5E5B', 'close-icon')), /*#__PURE__*/React__default['default'].createElement("h5", {
    style: {
      color: '#FF5E5B'
    }
  }, "Stop Subscribing")), isPayingIndividual && !isNotCancelled && /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem,
    onClick: function onClick() {
      keepPlan({
        planOptionId: currentPlanOptionId,
        publisherId: publisherId,
        subscriptionId: currentSubscriptionId
      });
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'keep-icon')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Keep Subscription")))));
};

ManagePlanSubscription.defaultProps = {
  publisherId: null,
  pubPriceChangeDate: null
};
ManagePlanSubscription.propTypes = {
  changeMenuRoute: PropTypes__default['default'].func.isRequired,
  publisherId: PropTypes__default['default'].string,
  router: PropTypes__default['default'].shape({
    pathname: PropTypes__default['default'].string,
    query: PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      short_code: PropTypes__default['default'].string
    })
  }).isRequired,
  nextPlan: PropTypes__default['default'].shape({
    plan_option_currency: PropTypes__default['default'].string.isRequired
  }).isRequired,
  currentPlanOptionCurrency: PropTypes__default['default'].string.isRequired,
  utmRootUrl: PropTypes__default['default'].string,
  queryOverride: PropTypes__default['default'].object,
  pubPriceChangeDate: PropTypes__default['default'].string
};

var ManagePlanSubscriptionFinished = function ManagePlanSubscriptionFinished(_ref) {
  var changeMenuRoute = _ref.changeMenuRoute,
      userLoader = _ref.userLoader,
      guestLoader = _ref.guestLoader,
      utmRootUrl = _ref.utmRootUrl,
      queryOverride = _ref.queryOverride;
  var scopedLoader = userLoader || guestLoader || {};
  var _scopedLoader$publish = scopedLoader.publisher;
  _scopedLoader$publish = _scopedLoader$publish === void 0 ? {} : _scopedLoader$publish;
  var publisherName = _scopedLoader$publish.name,
      _scopedLoader$publish2 = _scopedLoader$publish.styling;
  _scopedLoader$publish2 = _scopedLoader$publish2 === void 0 ? {} : _scopedLoader$publish2;
  var _scopedLoader$publish3 = _scopedLoader$publish2.linkColor,
      linkColor = _scopedLoader$publish3 === void 0 ? '' : _scopedLoader$publish3;
  return /*#__PURE__*/React__default['default'].createElement(MenuWrapper__default['default'], {
    publisherName: publisherName,
    utmRootUrl: utmRootUrl,
    queryOverride: queryOverride
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.menuHeader
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.backIcon,
    onClick: function onClick() {
      changeMenuRoute('/');
    },
    style: {
      color: linkColor
    }
  }, functions.getSvgImage(linkColor, 'back-icon')), /*#__PURE__*/React__default['default'].createElement("h3", null, "Manage Subscription")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.container
  }, /*#__PURE__*/React__default['default'].createElement("ul", {
    className: style.menuContainer,
    style: {
      color: linkColor,
      borderBottom: '1px solid #ddd'
    }
  }, /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.list
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    className: style.listTitle
  }, "SUBSCRIBER SINCE"), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default'](style.regularColor)
  }, "April 24, 2020"))), /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.list
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    className: style.listTitle
  }, "FINAL PAYMENT"), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default'](style.regularColor)
  }, "$10 on April 24, 2020"))), /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.list
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.mainMenuItem, style.listItemFluid)
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: classNames__default['default'](style.regularColor)
  }, "Your subscription is set to end on", /*#__PURE__*/React__default['default'].createElement("strong", null, "April 25, 2021"))))), /*#__PURE__*/React__default['default'].createElement("ul", {
    className: classNames__default['default'](style.menuContainer, style.planOption),
    style: {
      color: linkColor
    }
  }, /*#__PURE__*/React__default['default'].createElement("li", {
    className: style.mainMenuItem,
    onClick: function onClick() {
      changeMenuRoute('/');
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.imgContainer, style.circle),
    style: {
      backgroundColor: functions.colors.getBgColor(linkColor, 0.15)
    }
  }, functions.getSvgImage(linkColor, 'keep-icon')), /*#__PURE__*/React__default['default'].createElement("h5", null, "Keep Subscription")))));
};

ManagePlanSubscriptionFinished.propTypes = {
  changeMenuRoute: PropTypes__default['default'].func.isRequired,
  utmRootUrl: PropTypes__default['default'].string,
  userLoader: PropTypes__default['default'].any.isRequired,
  guestLoader: PropTypes__default['default'].any.isRequired,
  queryOverride: PropTypes__default['default'].object
};

var ManagePlanSubscriptionStopSubscription = function ManagePlanSubscriptionStopSubscription(_ref) {
  var changeMenuRoute = _ref.changeMenuRoute,
      currentPlanOptionId = _ref.currentPlanOptionId,
      cancelPlan = _ref.cancelPlan,
      _ref$linkColor = _ref.linkColor,
      linkColor = _ref$linkColor === void 0 ? '' : _ref$linkColor,
      memberType = _ref.memberType,
      _ref$memberVerbPresen = _ref.memberVerbPresentParticiple,
      memberVerbPresentParticiple = _ref$memberVerbPresen === void 0 ? '' : _ref$memberVerbPresen,
      nextPlanSubscriptionEnd = _ref.nextPlanSubscriptionEnd,
      publisherId = _ref.publisherId,
      publisherName = _ref.publisherName,
      utmRootUrl = _ref.utmRootUrl,
      queryOverride = _ref.queryOverride;
  var contrastColor = functions.colors.getContrastColor(linkColor);
  var descriptionText = memberType === 'donor' ? /*#__PURE__*/React__default['default'].createElement("span", null, "Your monthly donation provides critical support to", ' ', publisherName, ".") : /*#__PURE__*/React__default['default'].createElement("span", null, "Your plan benefits would stop after the current billing cycle ends on", ' ', /*#__PURE__*/React__default['default'].createElement("strong", null, moment__default['default'](nextPlanSubscriptionEnd).format('LL')), ".");
  return /*#__PURE__*/React__default['default'].createElement(MenuWrapper__default['default'], {
    publisherName: publisherName,
    utmRootUrl: utmRootUrl,
    queryOverride: queryOverride
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](style.menuHeader, style.withoutIcon)
  }, /*#__PURE__*/React__default['default'].createElement("h3", null, "Are you sure you want to stop", ' ', memberVerbPresentParticiple, "?")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.container
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.menuDescription
  }, /*#__PURE__*/React__default['default'].createElement("p", null, descriptionText)), /*#__PURE__*/React__default['default'].createElement("div", {
    "data-menu_route": "/logOut"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.approveButtonGroup
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    onClick: function onClick() {
      changeMenuRoute('/');
    },
    style: {
      color: linkColor
    },
    className: style.cancel
  }, "Cancel"), /*#__PURE__*/React__default['default'].createElement("span", {
    onClick: function onClick() {
      cancelPlan({
        planOptionId: currentPlanOptionId,
        publisherId: publisherId
      });
    },
    className: classNames__default['default'](style.button, style.danger),
    style: {
      backgroundColor: '#ff5e5b',
      color: contrastColor
    }
  }, "Stop ".concat(functions.Capitalize(memberVerbPresentParticiple)))))));
};

ManagePlanSubscriptionStopSubscription.defaultProps = {
  publisherId: null
};
ManagePlanSubscriptionStopSubscription.propTypes = {
  changeMenuRoute: PropTypes__default['default'].func.isRequired,
  publisherId: PropTypes__default['default'].string,
  router: PropTypes__default['default'].shape({
    pathname: PropTypes__default['default'].string,
    query: PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      short_code: PropTypes__default['default'].string
    })
  }).isRequired,
  utmRootUrl: PropTypes__default['default'].string,
  queryOverride: PropTypes__default['default'].object
};

var MenuRoutes = {
  Root: Root,
  EditProfile: {
    Root: EditProfile,
    EditName: EditProfileEditName,
    EditEmail: EditProfileEditEmail,
    EditPassword: EditProfileEditPassword,
    DeleteAccount: EditProfileDeleteAccount
  },
  LogOut: {
    Root: Logout
  },
  ManageNewsletters: {
    Root: ManageNewsletters
  },
  Notification: {
    Root: NotificationMenuPage,
    CancelPlan: NotificationMenuPage$1,
    KeepPlan: NotificationMenuPage$2,
    SwitchPlanSuccess: NotificationMenuPage$3
  },
  ManagePlan: {
    Root: ManagePlan,
    CancelPlan: ManagePlanCancelPlan,
    Donation: {
      Root: ManagePlanDonation,
      Change: ManagePlanDonationChange
    },
    Gift: ManagePlanGift,
    Membership: ManagePlanMembership,
    Pass: ManagePlanPass,
    SwitchPlan: ManagePlanSwitchPlan,
    Subscription: {
      Root: ManagePlanSubscription,
      Finished: ManagePlanSubscriptionFinished,
      StopSubscription: ManagePlanSubscriptionStopSubscription
    }
  }
};

module.exports = MenuRoutes;
